/* eslint-disable */
import _ from "lodash";
import { useRef } from "react";
import embLabels from "../../../config/emb-labels-en.json";
import ACTIONS from "../Design_Asset_Actions.json";
import PROJECT_ACTION from "../Actions/projectKind.json";
import ApiSession from "../../../api/ApiSession";
import { padNumberFormat, applyPriorityRules, pvSetGroupName } from "./designAssetUtils";
import { assignIpAddress } from "../../../utils/assignIPAddress";
import { coOrdinateValidator } from "../../../utils/coOrdinateValidator";
import { getProjectTypeValue } from "../../../utils/project";
import { MGAAS_ANSI, MGAAS_ETO, NMGAAS_ETO, MGaaS_IEC } from "../../../utils/application.constants";

const apiSession = new ApiSession();
const FORCE_TRANSITION_UPDATE_KEY = "forceTransitionUpdatePending";

const useGenerateComponents = (deps) => {
  const {
    projectTypeValue, dispatch, UserScope, projectType,
    loading, setLoading,
    displayPage, setDisplayPage,
    sldLoadCompleted, setSldLoadCompleted,
    useCaseValidGenset, setUseCaseValidGenset,
    deleteOneDER, setDeleteOneDER,
    defaultConfigurationStatus, setDefaultConfigurationStatus,
    siteCreated, setSiteCreated,
    isOpen, setIsOpen,
    siteType, setSiteType,
    evceDiagramChangeRequired, setEvceDiagramChangeRequired,
    isAllowMultipleLoads, setIsAllowMultipleLoads,
    isExportOptimization, setIsExportOptimization,
    switchboardType, setSwitchboardType,
    clientType, setClientType,
    architectureType, setArchitectureType,
    nominalVoltage, setNominalVoltage,
    isSelectSpanishCode, setIsSelectSpanishCode,
    defaultPreFillData, setDefaultPreFillData,
    availableDer, setAvailableDer,
    useCases, setUseCases,
    isEvce, setIsEvce,
    prevPvGroupNames, setPrevPvGroupNames,
    batteryCommunicationData, setBatteryCommunicationData,
    evCommunicationData, setEvCommunicationData,
    powerMeter, setPowerMeter,
    communicationState, setCommunicationState,
    cbCommunicationValues, setCbCommunicationValues,
    detailsBlock, setDetailsBlock,
    selectedValues, setSelectedValues,
    configData, setConfigData,
    isLoadNameUnique, setIsLoadNameUnique,
    gsxExternalId, setGsxExternalId,
    isBessController, setIsBessController,
    assetDetailsDisplay, setAssetDetailsDisplay,
    assetInfo, setAssetInfo,
    bessControllerPrevValue, setBessControllerPrevValue,
    cbDer, setCbder,
    CBValues, setCBValues,
    defaultsMinMax, setDefaultsMinMax,
    coordinates, setCoordinates,
    rectangleWidth, setRectangleWidth,
    snackBar, setSnackBar,
    alert, setAlert,
    confirm, setConfirm,
    remoteConfirm, setRemoteConfirm,
    duplicateUpdate, setDuplicateUpdate,
    runCalculateCoordinates, setRunCalculateCoordinates,
    runGenerateComponentsBlock, setRunGenerateComponentsBlock,
    batteryRack, setBatteryRack,
    batterySystemA2EConfig, setBatterySystemA2EConfig,
    isOpenLoadConfig, setIsOpenLoadConfig,
    isOpenGtConfig, setIsOpenGtConfig,
    loadSide, setLoadSide,
    isAntiIslandingRelayEnable, setIsAntiIslandingRelayEnable,
    gridTransitionOnline, setGridTransitionOnline,
    defaultCbData, setDefaultCbData,
    defaultPmData, setDefaultPmData,
    defaultDummyCbData, setDefaultDummyCbData,
    gensetAssetData, setGensetAssetData,
    evContactorData, setEVContactorData,
    gTContractorData, setGTContractorData,
    defaultGTData, setGTDefaultData,
    evDefaultData, setEVDefaultData,
    evPMData, setEVPMData,
    jsonData, setJsonData,
    isContactorEnabled, setIsContactorEnabled,
    cbLoadData, setCBLoadData,
    currentProject, setCurrentProject,
    defaultComponentData, setDefaultComponentData,
    updateComponents, setUpdateComponents,
    cbCount, setCbCount,
    spanishCodeRealTime, setSpanishCodeRealTime,
    assetDefaultValues, setAssetDefaultValues,
    isAssetConfigChanged, setIsAssetConfigChanged,
    gtTempConfigData, setGtTempConfigData,
    projectStatusData,
    deploymentReady, setDeploymentReady,
    ComponentData, ComponentDataDispatch,
    CBAssetList, CBAssetListDispatch,
    CBEVList, CBEVListDispatch,
    CBLoadList, CBLoadListDispatch,
    CBGTList, CBGTListDispatch,
    firstTimeCall, setFirstTimecall,
    multipleLoads, setMultipleLoads,
    count, countDispatch,
    projectKind, projectKindDispatch,
    PVDetails, PVDetailsDispatch,
    selectedLoadIndx, setSelectedLoadIndx,
    projectId,
    initialRenderCoordinates,
    initialRenderPvConfigured,
    snackBarRef,
    isUpdatingComponent,
    remoteMain, setRemoteMain,
    considerSelected, setConsiderSelected,
    assetDetails, setAssetDetails,
    // projectKind flags
    isMgaasAnsi, isDaasAnsi, isDaasEto, isMgaasIec, isDaasIec,
    isMgaasAnsiGrid, isDaasAnsiGrid, isDaasEtoGrid,
    isMgaasAnsiIsland, isDaasAnsiIsland, isDaasEtoIsland,
    isMgaasIecGrid, isDaasIecGrid, isMgaasIecIsland,
    isGridConnected, isGridConnectedGSX, isIslandable, isIslandableGSX,
    isA2E, isLineSide, isExistingSwitchBoard, isLoadSide, isNewSwitchBoard,
    isGreenStruxure, isGeneric, isGreenStruxureMicrogrid,
    isPVGensetATS, isFuelSaver, isPVBessNR, isPVHybrid, isPVGensetA2E,
    isGensetMainNoBess, isNoFuel, isETO,
    isMGaaSETOGrid, isMGaaSETOIsland, isMGaaSETO, isMGaaSETOGensetPvHybrid,
    isNMGaaSETOGrid, isNMGaaSETOIsland, isNMGaaSETO, isNMGaaSETOGensetPvHybrid,
    isMgaasAnsiOffGrid, isMgaasIecOffGrid, isMassEtoOffGrid,
    // cross-hook ref
    fnRef,
  } = deps;

  // Cross-hook function aliases (resolved via fnRef at runtime)
  const callSnackbar = (...args) => fnRef.current.callSnackbar(...args);
  const checkGensetDeleteOneDER = (...args) => fnRef.current.checkGensetDeleteOneDER(...args);
  const upDateCbcount = (...args) => fnRef.current.upDateCbcount(...args);
  const filterHybridModel = (...args) => fnRef.current.filterHybridModel(...args);
  const pendingComponentUpdateRef = useRef(null);
const isMissingIdentity = (value) => value === undefined || value === null || value === "";

  const getComponentSignature = (component) => {
    const type = component?.componentType ?? "";
    const name = (component?.componentName ?? "").trim().toLowerCase();
    return `${type}::${name}`;
  };

  const getPreviousComponentsForIdentity = () => {
    const fromComponentState = Array.isArray(ComponentData?.components)
      ? ComponentData.components
      : Array.isArray(ComponentData)
        ? ComponentData
        : [];
    if (fromComponentState.length) return fromComponentState;

    if (Array.isArray(jsonData) && jsonData.length) {
      return jsonData;
    }

    try {
      const fromSession = JSON.parse(sessionStorage.getItem("componentJsonData") || "{}");
      return Array.isArray(fromSession?.components) ? fromSession.components : [];
    } catch (e) {
      return [];
    }
  };

  const preserveGeneratedComponentIdentity = (nextComponents = []) => {
    if (!Array.isArray(nextComponents) || !nextComponents.length) {
      return nextComponents;
    }

    const previousComponents = getPreviousComponentsForIdentity();
    if (!previousComponents.length) {
      return nextComponents;
    }

    const byComponentId = new Map();
    const byComponentIdx = new Map();
    const bySignature = new Map();

    previousComponents.forEach((component) => {
      if (!component) return;
      if (!isMissingIdentity(component.componentId)) {
        byComponentId.set(String(component.componentId), component);
      }
      if (component.componentIdx) {
        byComponentIdx.set(component.componentIdx, component);
      }
      const signature = getComponentSignature(component);
      const existing = bySignature.get(signature) || [];
      existing.push(component);
      bySignature.set(signature, existing);
    });

    return nextComponents.map((component) => {
      if (!component) return component;

      let matchedComponent;
      if (!isMissingIdentity(component.componentId)) {
        matchedComponent = byComponentId.get(String(component.componentId));
      }
      if (!matchedComponent && component.componentIdx) {
        matchedComponent = byComponentIdx.get(component.componentIdx);
      }
      if (!matchedComponent) {
        const candidates = bySignature.get(getComponentSignature(component)) || [];
        if (candidates.length === 1) {
          matchedComponent = candidates[0];
        }
      }

      if (!matchedComponent) {
        return component;
      }

      const componentWithIdentity = { ...component };
      if (
        isMissingIdentity(componentWithIdentity.componentId) &&
        !isMissingIdentity(matchedComponent.componentId)
      ) {
        componentWithIdentity.componentId = matchedComponent.componentId;
      }
      if (isMissingIdentity(componentWithIdentity.uuid) && !isMissingIdentity(matchedComponent.uuid)) {
        componentWithIdentity.uuid = matchedComponent.uuid;
      }

      return componentWithIdentity;
    });
  };

  const calculateCoOridinates = (componentPush) => {

    // The CBAssetList/CBLoadList dispatches below are not committed yet in this tick, so defer the
    // payload build and resolve via fnRef to pick up the updated lists.
    const pushComponents = () => {
      setTimeout(() => fnRef.current.generateComponentsBlock(), 0);
    };

    if (
      isIslandable &&
      !isMgaasAnsi
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count, siteType: siteType, projectKind: projectKind, switchboardType },
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count },
      });

      let ecc = { ...coordinates.ecc };
      let busbar = { ...coordinates.busbar };
      const totalLoads = count.loadCount + count.evCount;

      if (count.derCount > count.loadCount + count.evCount) {
        if (totalLoads >= 10) {
          ecc.width = 1250;
          busbar.x2 = 1255;
        } else {
          ecc.width = coordinates.eccwidth + (count.derCount - 1) * 110;
          busbar.x2 = coordinates.busbarx2 + (count.derCount - 1) * 110;
        }
      } else {
        if (totalLoads >= 11) {
          ecc.width = 1250;
          busbar.x2 = 1255;
        } else {
          ecc.width = coordinates.eccwidth + (totalLoads - 1) * 110;
          busbar.x2 = coordinates.busbarx2 + (totalLoads - 1) * 110;
        }
      }

      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        ecc,
        busbar,
      }));

      if (componentPush) {
        // resolve through fnRef so the deferred call uses the latest CBAssetList/PVDetails, not this render's snapshot
        setTimeout(() => {
          fnRef.current.generateComponentsBlock();
        }, 1000);
      }
      checkAssetStatus();
    }

    // Add OffGrid logic to trigger generateComponentsBlock
    if (siteType === embLabels.OFF_GRID) {
      // Add any OffGrid-specific coordinate logic here if needed
      if (componentPush) {
        pushComponents();
      }
      checkAssetStatus();
    }

    if
      (isGridConnected &&
      !isMgaasAnsi
    ) {
      let x21 =
        count.derCount === 2
          ? "695"
          : count.derCount === 3
            ? "870"
            : count.derCount === 4
              ? "985"
              : count.derCount === 5
                ? switchboardType === embLabels.EXISTING_SWITCHBOARD
                  ? "1145"
                  : "1045"
                : "795";

      if (switchboardType === embLabels.EXISTING_SWITCHBOARD) {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "480",
          xDerCBDiff: "700",
          yDerGrid: "243",
          yDerCBDiff: "370",
          xDerGridPM: "605",
          yDerGridPM: "227.5",
          cbEV: {
            xDerEV: 597.5,
            yDerEV: 492,
            xDerPM: 545,
            yDerPM: 487.5,
            x1DerEVCB: 675,
            y1DerEVCB: 570,
            x2DerEVCB: 675,
            y2DerEVCB: 464,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "126",
            y11: "280",
            x21: "345",
            y21: "280",
            x12: "620",
            y12: "470",
            x22: x21,
            y22: "470",
          },
        }));
      } else {
        let x21 =
          count.derCount === 2
            ? "695"
            : count.derCount === 3
              ? "810"
              : count.derCount === 4
                ? "915"
                : count.derCount === 5
                  ? "1045"
                  : "795";

        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "370",
          xDerCBDiff: "590",
          yDerGrid: "141",
          yDerCBDiff: "269",
          xDerGridPM: "495",
          yDerGridPM: "127.5",
          cbEV: {
            xDerEV: 707.5,
            yDerEV: 553,
            xDerPM: 655,
            yDerPM: 555.5,
            x1DerEVCB: 555,
            y1DerEVCB: 463,
            x2DerEVCB: 555,
            y2DerEVCB: 367,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "426",
            y11: "370",
            x21: x21,
            y21: "370",
          },
        }));
      }

      // CBAssetListDispatch({
      //   type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
      //   payload: { coordinates: coordinates },
      // });
      // CBLoadListDispatch({
      //   type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
      // });
      // CBEVListDispatch({
      //   type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
      // });

      if (componentPush) {
        pushComponents();
      }
      checkAssetStatus();
    }

    if (isMgaasAnsiGrid) {
      if (isExistingSwitchBoard) {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 530,
            yDerEV: 490,
            xDerPM: 475,
            yDerPM: 490,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },

        }));
      } else {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 300,
            yDerEV: 320,
            xDerPM: 245,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },

        }));
      }
    } else if (isMgaasAnsiIsland) {
      if (isExistingSwitchBoard) {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 635,
            yDerEV: 450,
            xDerPM: 475,
            yDerPM: 490,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },

        }));
      } else {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 80,
            yDerEV: 320,
            xDerPM: 25,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },

        }));
      }
    }

    if (siteType === embLabels.PV_HYBRIDIZATION) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVHYBRIDIZATION,
        payload: { coordinates: coordinates, switchType: switchboardType },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVHYBRIDIZATION,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "426",
          y11: "360",
          x21: "815",
          y21: "360",
        },
      }));
      if (componentPush) {
        pushComponents();
      }
      checkAssetStatus();
    }

    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      clientType === embLabels.GREENSTRUXURE_PROJECT &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1].mode !== "FUEL_SAVER"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS,
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "168",
          y11: "290",
          x21: "408",
          y21: "290",
          x12: "670",
          y12: "430",
          x22: "840",
          y22: "430",
        },
      }));
      if (componentPush) {
        pushComponents();
      }
      checkAssetStatus();
    }

    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      ((siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType: switchboardType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide: loadSide,
        }
      });
      // CBLoadListDispatch({
      //   type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS,
      // });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });
      if (switchboardType === embLabels.EXISTING_SWITCHBOARD && (isMgaasAnsiIsland || isDaasAnsiIsland || isDaasEtoIsland)) {
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
          payload: { coordinates: coordinates, loadSide: loadSide, count: count, siteType: siteType, projectKind: projectKind, switchboardType },
        });
      }

      let x22;
      if (count.derCount <= 3 && count.loadCount <= 4) {
        x22 = "1095";
      } else if (count.derCount <= 4 && count.loadCount <= 4) {
        siteType === "GRID_CONNECTED_GSX" ||
          (["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType) &&
            (switchboardType === "" ||
              switchboardType === embLabels.EXISTING_SWITCHBOARD))
          ? (x22 = "1095")
          : (x22 = "510");
      } else if (count.derCount <= 4 && count.loadCount === 5) {
        switchboardType === embLabels.NEW_SWITCHBOARD &&
          ["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType)
          ? (x22 = 570)
          : (x22 = "1170");
      } else if (count.loadCount === 10) {
        switchboardType === embLabels.NEW_SWITCHBOARD &&
          ["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType)
          ? (x22 = 650)
          : (x22 = "1250");
      } else {
        {
          ["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType) &&
            switchboardType === embLabels.NEW_SWITCHBOARD
            ? (x22 = "620")
            : (x22 = "1170");
        }
      }

      // x21: "594",

      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "158",
          y11: "285",
          x21: "330",
          y21: "285",
          x12: "630",
          y12: "430",
          x22: x22,
          y22: "430",
        },
      }));
      if (componentPush) {
        pushComponents();
      }
      checkAssetStatus();
    }

    if (
      (siteType === embLabels.GRID_CONNECTED_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_BESS_NR) ||
      (siteType === embLabels.GRID_CONNECTED &&
        projectTypeValue === "MGaaS ANSI")
    ) {
      const x21 = count.derCount === 2 ? "815" : "715";
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType: switchboardType,
          mode: "",
          clientType: "",
          loadSide: projectKind?.isLoadSide ? "LOAD_SIDE" : "LINE_SIDE",
          projectKind: projectKind
        }
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVBESS_NR,
        payload: switchboardType,
      });
      let x22;
      if (count.derCount > 3) {
        setRectangleWidth(530);
        if (
          ["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
          (switchboardType === "" ||
            switchboardType === embLabels.EXISTING_SWITCHBOARD)
        ) {
          x22 = 1065;
        } else {
          ["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
            switchboardType === embLabels.NEW_SWITCHBOARD
            ? (x22 = 690)
            : (x22 = 640);
          setRectangleWidth(730);
        }
      } else {
        if (
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchboardType === "" ||
              switchboardType === embLabels.EXISTING_SWITCHBOARD))
        ) {
          setRectangleWidth(420);
          x22 = 965;
        } else {
          setRectangleWidth(580);
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
            (siteType !== "ISLANDABLE_GSX" &&
              (switchboardType !== "" ||
                switchboardType !== embLabels.EXISTING_SWITCHBOARD))
            ? (x22 = 510)
            : (x22 = 965);
        }
      }
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "168",
          y11: "283",
          x21: "408",
          y21: "283",
          x12: "630",
          y12: "430",
          x22,
          y22: "430",
        },
      }));

      if (componentPush) {
        pushComponents();
      }
      checkAssetStatus();
    }
    if ((siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) && projectTypeValue === "MGaaS ANSI") {
      if (switchboardType === embLabels.EXISTING_SWITCHBOARD) {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 250,
            yDerEV: 290,
            xDerPM: 195,
            yDerPM: 330,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },

        }));
      } else {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 80,
            yDerEV: 320,
            xDerPM: 25,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },

        }));
      }
    }
    if ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland || projectKind?.isNMGaaSETOIsland)) {
      if (switchboardType === embLabels.EXISTING_SWITCHBOARD) {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 310,
            yDerEV: 475,
            xDerPM: 255,
            yDerPM: 515,
            x1DerEVCB: 355,
            y1DerEVCB: 470,
            x2DerEVCB: 355,
            y2DerEVCB: 470,
          },

        }));
      } else {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 300,
            yDerEV: 365,
            xDerPM: 245,
            yDerPM: (isMgaasIecIsland || isNMGaaSETOIsland) ? 384 : 370,
            x1DerEVCB: isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland ? 379 : 345,
            y1DerEVCB: 370,
            x2DerEVCB: 378,
            y2DerEVCB: isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland ? 460 : 300,
          },

        }));
      }
    }
    CBEVListDispatch({
      type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
      payload: { coordinates: coordinates, count: count },
    });
    if (
      siteType === embLabels.GENSET_PVBESS_A2E &&
      clientType === embLabels.A2E_PROJECT
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GENSET_PVBESS_A2E,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GENSET_PVBESS_A2E,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "426",
          y11: "360",
          x21: "815",
          y21: "360",
        },
      }));
      checkAssetStatus();

    }
    if (isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_ISLANDABLE,
        payload: {
          switchType: switchboardType,
          mode: defaultPreFillData[1]?.mode,
          projectKind: projectKind,
        },
      });
    }
    if (switchboardType === embLabels.EXISTING_SWITCHBOARD && (isMgaasAnsiIsland || isDaasAnsiIsland || isDaasEtoIsland)) {
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
        payload: { coordinates: coordinates, loadSide: loadSide, count: count, siteType: siteType, projectKind: projectKind, switchboardType },
      });
    }
    let x11, y11, x21, y21, x12, y12, x22, y22;
    let coOrdinates = { x11, y11, x21, y21, x12, y12, x22, y22 };
    const coOrdinateLists = coOrdinateValidator(
      coOrdinates,
      switchboardType,
      siteType,
      projectType || projectTypeValue,
      count,
      rectangleWidth,
      loadSide,
      clientType,
      defaultPreFillData[1]?.mode,
      projectKind,
    );
    setRectangleWidth(coOrdinateLists.rectangleWidth);
    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      busbarCordinates: {
        ...prevCoordinates.busbarCordinates,
        ...coOrdinateLists.cooridinates,
      },
    }));
  };

  const checkAssetStatus = () => {
    let componentConfigStatus = true;
    CBAssetList?.forEach((componentData, index) => {
      if (!componentData) return;
      if (componentData.uiData.status && [0, 1, 2, 3, 4, 5, 6, 7].includes(index)) {
        if (!componentData.uiData.configured) {
          componentConfigStatus = false;
        }
      }
      if (componentData?.uiData?.status) {
        if (
          !componentData?.uiData?.CBConfigured &&
          componentData?.uiData?.cbRequired
        ) {
          componentConfigStatus = false;
        }
        // if ( 
        //   !componentData?.uiData?.CBConfigured && ( siteType === embLabels.PV_HYBRIDIZATION)
        // ) {
        //   componentConfigStatus = false;
        // }
        // if (
        //   !componentData?.uiData?.pmRequired &&
        //   !(componentData?.uiData?.pmConfiguredGrid === undefined||componentData?.uiData?.pmConfiguredGrid)
        // ) {
        //   componentConfigStatus = false;
        // }
        if (
          componentData?.uiData?.pmRequired &&
          !componentData?.uiData?.pmConfiguredGrid && ['DaaS ANSI', 'DaaS ETO', 'DaaS IEC', 'MGaaS ANSI', 'MGaaS IEC', 'MGaaS ETO', "NMGaaS ETO"].includes(projectTypeValue)
        ) {
          componentConfigStatus = false;
        }
        if (componentData?.uiData?.pmRequired && !componentData.uiData.pmConfigured &&
          !componentData?.uiData?.pmConfigured && ["MGaaS AccessToEnergy"].includes(projectTypeValue)) {
          componentConfigStatus = false;
        }

      }
    });
    CBEVList?.forEach((componentData) => {
      if (!componentData) return;
      if (componentData?.uiData?.status) {
        if (
          !componentData?.uiData?.configured ||
          (componentData?.uiData?.cbRequired && !componentData?.uiData?.CBConfigured) ||
          (componentData?.uiData?.pmRequired &&
            !componentData?.uiData?.pmConfiguredGrid)
        ) {
          componentConfigStatus = false;
        }
      }
    });
    CBGTList.forEach((componentData) => {
      if (componentData.uiData.status) {
        if (componentData.uiData.cbRequired && !componentData.uiData.CBConfigured) {
          componentConfigStatus = false;
        }
      }
    });
    if (
      [
        embLabels.ISLANDABLE,
        embLabels.OFF_GRID,
        embLabels.GRID_CONNECTED,
        embLabels.GENSET_PVBESS_A2E,
        embLabels.PV_HYBRIDIZATION
      ].includes(siteType) ||
      (siteType === embLabels.GRID_CONNECTED_GSX && isDaasEtoGrid) ||
      (siteType === embLabels.ISLANDABLE_GSX &&
        defaultPreFillData[1].mode === "FUEL_SAVER")
    ) {
      CBLoadList.forEach((componentData) => {
        if (componentData?.uiData?.status) {
          if (
            !componentData?.uiData?.configured &&
            !(isMgaasAnsi)
            && !isGridConnected
          ) {
            componentConfigStatus = false;
          }
          if (!componentData?.uiData?.configured && (isMGaaSETO || isNMGaaSETO || isMgaasIec || isMgaasAnsi)) {
            componentConfigStatus = false;
          }
          if ((isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland || isNMGaaSETOGensetPvHybrid) && (componentData.uiData.pmRequired &&
            !componentData.uiData.pmConfiguredGrid)) {
            componentConfigStatus = false;

          }
          if ((isMgaasAnsiIsland || isDaasAnsiIsland || isDaasEtoIsland) && (componentData.uiData.pmRequired &&
            !componentData.uiData.pmConfiguredGrid)) {
            componentConfigStatus = false;

          }
          if (!componentData?.uiData?.CBConfigured && !(isMGaaSETOIsland || isNMGaaSETOIsland || isMgaasIecIsland || isMgaasIecGrid || isA2E || isMGaaSETOGensetPvHybrid || isNMGaaSETOGensetPvHybrid || isMassEtoOffGrid || isMgaasIecOffGrid || isMgaasAnsiOffGrid) && !isGridConnected) {
            componentConfigStatus = false;
          } else if ((isMGaaSETOIsland || isNMGaaSETOIsland || isMgaasIecIsland || isMGaaSETOGensetPvHybrid || isNMGaaSETOGensetPvHybrid || isMassEtoOffGrid || isMgaasIecOffGrid || isMgaasAnsiOffGrid) && componentData?.uiData?.cbRequired && !componentData?.uiData?.CBConfigured) {
            componentConfigStatus = false;
          }
          if (isNMGaaSETOGrid && isExportOptimization && componentData?.uiData?.cbRequired && !componentData?.uiData?.CBConfigured) {
            componentConfigStatus = false;
          }
        }
      });
    }

    PVDetails?.pvset1Data.forEach((pvData) => {
      if (!pvData.status) {
        componentConfigStatus = false;
      }
    });
    PVDetails?.pvset2Data.forEach((pvData) => {
      if (!pvData.status) {
        componentConfigStatus = false;
      }
    });
    PVDetails?.pvset3Data.forEach((pvData) => {
      if (!pvData.status) {
        componentConfigStatus = false;
      }
    });
    sessionStorage.setItem("deploymentReady", componentConfigStatus);
    setDeploymentReady(`${componentConfigStatus}`);
    return componentConfigStatus;
  };

  const checkExportOptimizationCondition = () => {
    if (
      defaultPreFillData[1]?.exportOptimization &&
      !CBAssetList[2]?.uiData?.status
    ) {
      if (UserScope.access.saveSLD) {
        setTimeout(() => {
          if (siteType !== embLabels.GRID_CONNECTED) {
            // addBattery();
          }
        }, 300);
      }
    }
  };

  //* padNumberFormat, isDuplicates, pvSetGroupName, DER, prorityRules
  //* are now imported from designAssetUtils.js

  const saveDraftComponentData = () => {
    sessionStorage.setItem("componentDataModified", false);
    localStorage.setItem("assetEditStatus", `"",false`);
    const componentJson = JSON.parse(sessionStorage.getItem("componentJsonData"));
    // JSON.parse is globally patched to return the raw string on failure, so verify the shape before posting
    if (!_.isPlainObject(componentJson) || !Array.isArray(componentJson.components)) {
      console.warn("saveDraftComponentData: invalid componentJsonData in sessionStorage, skipping auth/component POST");
      return;
    }
    setTimeout(() => {
      updateComponentRemote(componentJson);
    }, 200)
  }

  const generateComponentsBlock = () => {
    const componentJson = {
      projectId: "",
      deploymentReady: true,
      programPage: true,
      components: [],
      switchboardType: switchboardType,
      remoteMain: remoteMain,
      connectionType: null,
    };

    if (
      siteType === embLabels.GRID_CONNECTED_GSX ||
      siteType === embLabels.ISLANDABLE || siteType === embLabels.ISLANDABLE_GSX || siteType === embLabels.OFF_GRID ||
      siteType === embLabels.GRID_CONNECTED
    ) {
      componentJson.connectionType = loadSide;
    }
    componentJson.projectId = projectId
      ? projectId
      : "1";
    componentJson.userId = 1;
    let arrayComponent = [];
    let assetCB = 10;
    let assetI = 1;
    //* assets
    const CBAssetListNew = _.cloneDeep(CBAssetList);
    //cb conncetion done here
    CBAssetListNew.map((cbData, key) => {
      if (cbData?.uiData.status) {
        let CBComponentIdx = "CB_10";
        let CRComponentIdx = "Contactor_10";
        let PMComponentIdx = "PM_10";
        switch (cbData?.assetType) {
          case embLabels.UTILITY:
          case embLabels.GENSET:
          case embLabels.BESS:
          case embLabels.CHP:
          case embLabels.HYBRID:
            let asset = {};
            if (cbData?.assetType === embLabels.UTILITY) {
              asset.assetId = 1;
              CBComponentIdx = "CB_10";
              CRComponentIdx = "Contactor_10";
              PMComponentIdx = "PM_10";
              asset.componentType = "Utility";
              asset.componentId = cbData?.componentId ?? null;
               asset.uuid = cbData?.uuid ?? null;
              asset.externalId = cbData?.externalId && cbData?.externalId !== "" && cbData?.externalId !== null
                ? cbData?.externalId
                : gsxExternalId?.utilityExternalId;
            }
            if (cbData?.assetType === embLabels.GENSET) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails[0]?.assetId;
              } else {
                asset.assetId = 2;
              }
              CBComponentIdx = "CB_20";
              CRComponentIdx = "Contactor_20";
              PMComponentIdx = "PM_20";
              asset.componentType = "Genset";
              asset.componentId = cbData?.componentId ?? null;
              asset.uuid = cbData?.uuid ?? null;
              asset.externalId = cbData?.externalId && cbData?.externalId !== "" && cbData?.externalId !== null
                ? cbData?.externalId
                : gsxExternalId?.utilityExternalId;
            }
            if (cbData?.assetType === embLabels.BESS) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails?.[0]?.assetId;
              } else {
                asset.assetId = 3;
              }
              CBComponentIdx = "CB_30";
              CRComponentIdx = "Contactor_30";
              PMComponentIdx = "PM_30";
              asset.componentType = "BESS";
              asset.componentId = cbData?.componentId ?? null;
              asset.uuid = cbData?.uuid ?? null;
              asset.externalId = cbData?.externalId && cbData?.externalId !== "" && cbData?.externalId !== null
                ? cbData?.externalId
                : gsxExternalId?.utilityExternalId;
            }

            //* CHP

            if (cbData?.assetType === embLabels.CHP) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails?.[0]?.assetId;
              } else {
                asset.assetId = 3;
              }
              CBComponentIdx = "CB_80";
              PMComponentIdx = "PM_80";
              asset.componentType = "CHP";
            }

            if (cbData?.assetType === embLabels.HYBRID) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails?.[0]?.assetId;
              } else {
                asset.assetId = 3;
              }
              CBComponentIdx = "CB_90";
              PMComponentIdx = "PM_90";
              asset.componentType = "Hybrid";

            }
            asset.userId = 1;
            asset.componentIdx = "ASSET_" + padNumberFormat(assetI);
            asset.componentName = cbData?.configData?.name;
            if (projectTypeValue === "DaaS ANSI" || projectTypeValue === "DaaS ETO") {
              asset.deviceName = cbData?.configData?.deviceName;
            }
            componentJson.deploymentReady =
              componentJson?.deploymentReady && cbData?.uiData?.configured
                ? true
                : false;
            asset.connections = [];
            asset.communications = [];
            asset.uiAttributes = JSON.stringify(cbData?.uiData);

            let assetConnections = {
              componentIdx: CBComponentIdx,
              endpointIdX: "1",
              connectionType: "electrical_connection",
            };
            let assetAttributes = {};
            if (cbData?.configData?.max_power != undefined && cbData?.configData?.max_power != "") {
              let values;
              if (cbData?.configData?.max_power) {
                values = JSON.parse(cbData?.configData?.max_power) || "0"
              }


              if (Array.isArray(values)) {
                const configDataNew = { ...cbData.configData }
                configDataNew.max_power = values[0];
                cbData.configData = configDataNew
              }
            }
            assetAttributes = cbData?.configData;
            if (cbData?.assetType === embLabels.GENSET) {
              delete assetAttributes?.min_power;
            }
            asset.attributes = JSON.stringify(assetAttributes);
            if (
              [
                embLabels.ISLANDABLE,
                embLabels.OFF_GRID,
                embLabels.PV_HYBRIDIZATION,
                embLabels.GENSET_PVBESS_A2E,
                embLabels.GRID_CONNECTED_GSX,
                embLabels.GRID_CONNECTED,
              ].includes(siteType) ||
              architectureType === embLabels.PV_GENSET_ATS
            ) {
              asset.connections.push(assetConnections);
            }

            if (cbData?.assetType === embLabels.GENSET) {
              if (
                cbData?.assetDetails.length && cbData?.assetDetails?.[0] &&
                cbData?.assetDetails?.[0]?.assetInfo === "Hardwired"
              ) {
                //*do nothing
              }
            }
            if (cbData?.assetType === embLabels.HYBRID) {
              asset.communications = [
                {
                  ip: cbData?.communicationDataBess?.ipaddress,
                  subnetmask: cbData?.communicationDataBess?.subnetmask,
                  defaultGateway: cbData?.communicationDataBess?.defaultGateway,
                  modbusSlaveId: cbData?.communicationDataBess?.modbusSlaveId,
                  type: "BESS",
                },
                {
                  ip: cbData?.communicationDataPv?.ipaddress,
                  subnetmask: cbData?.communicationDataPv?.subnetmask,
                  defaultGateway: cbData?.communicationDataPv?.defaultGateway,
                  modbusSlaveId: cbData?.communicationDataPv?.modbusSlaveId,
                  type: "PV",
                },
              ];
            } else if (
              (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO") &&
              // siteType === embLabels.GRID_CONNECTED &&
              cbData?.assetType === embLabels.BESS
            ) {
              asset.communications = [];
              if (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO") {
                if (
                  cbData?.assetDetails[0]?.communicationModel ===
                  "AC Coupled PCU"
                ) {
                  let assetCommunications = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.pcs_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.subnetMask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.defaultGateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.pcs_slaveid ??
                      cbData?.communicationDataPv?.modbusSlaveId,
                    type: "PCS",
                  };
                  asset.communications.push(assetCommunications);
                  let assetCommunications1 = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.mbms_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.subnetMask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.defaultGateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.mbms_slaveid ??
                      cbData?.communicationDataBess?.modbusSlaveId,
                    type: "MBMS",
                  };
                  asset.communications.push(assetCommunications1);
                } else if (
                  cbData?.assetDetails[0]?.communicationModel ===
                  "Schneider Boost Pro"
                ) {
                  let assetCommunications = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.eeac_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.eeac_subnetmask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.eeac_gateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.eeac_slaveid ??
                      cbData?.communicationDataPv?.modbusSlaveId,
                    type: "BESS",
                  };
                  asset.communications.push(assetCommunications);
                  let assetCommunications1 = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_subnetmask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_gateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_slaveid ??
                      cbData?.communicationDataPv?.modbusSlaveId,
                    type: "Miscellaneous",

                  };
                  asset.communications.push(assetCommunications1);
                } else if (cbData?.assetDetails[0]?.assetInfo === "Hardwired") {
                  asset.communications = [];
                } else {
                  let assetCommunications = {
                    ip: cbData?.communicationDataBess?.ipaddress ?? defaultPreFillData?.[0]?.["BESS"]?.ipAddress,
                    subnetmask: cbData?.communicationDataBess?.subnetMask ?? defaultPreFillData?.[0]?.["BESS"]?.subnetMask,
                    defaultGateway:
                      cbData?.communicationDataBess?.defaultGateway ?? defaultPreFillData?.[0]?.["BESS"]?.defaultGateway,
                    modbusSlaveId: cbData?.communicationDataBess?.modbusSlaveId ?? defaultPreFillData?.[0]?.["BESS"]?.modbusSlaveId,
                    type: "BESS",
                  };
                  asset.communications.push(assetCommunications);
                }
              }
            } else {
              if (cbData?.communicationData.modbusSlaveId) {
                let assetCommunications = {
                  ip: cbData?.communicationData?.ipaddress,
                  subnetmask: cbData?.communicationData?.subnetmask,
                  defaultGateway: cbData?.communicationData?.defaultGateway,
                  modbusSlaveId: cbData?.communicationData?.modbusSlaveId,
                  type: cbData?.assetDetails?.[0]?.communicationModel === "Master BESS Controller" ? "Master BESS Controller" : cbData?.assetType,
                };

                asset.communications.push(assetCommunications);

                if (cbData?.assetType === embLabels.GENSET || embLabels.BESS) {
                  if (cbData?.assetDetails?.length) {
                    if (cbData?.assetDetails?.[0]?.assetInfo === "Hardwired") {
                      asset.communications = [];
                    }
                  }
                }
              }
            }

            arrayComponent.push(asset);
            if (
              (siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID || siteType === embLabels.ISLANDABLE_GSX) ||
              (siteType === embLabels.GRID_CONNECTED &&
                cbData?.assetType === embLabels.BESS || cbData?.assetType === embLabels.UTILITY
                // &&cbData.uiData.cbRequired
              ) ||
              (projectKind?.isMgaasAnsiGrid && cbData?.assetType === embLabels.UTILITY) ||
              (siteType === embLabels.GRID_CONNECTED_GSX &&
                cbData?.assetType === embLabels.UTILITY
                // &&cbData.uiData.cbRequired
              ) ||
              (siteType === embLabels.ISLANDABLE_GSX &&
                defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
              (siteType === embLabels.ISLANDABLE_GSX &&
                defaultPreFillData[1]?.mode === "GENSET_MAIN_NO_BESS" &&
                cbData?.assetType === embLabels.UTILITY) ||
              (siteType === embLabels.PV_HYBRIDIZATION &&
                cbData?.assetType === embLabels.UTILITY) ||
              (siteType === embLabels.PV_HYBRIDIZATION &&
                cbData?.assetType === embLabels.GENSET || (
                  clientType === embLabels.A2E_PROJECT &&
                  siteType === embLabels.GENSET_PVBESS_A2E &&
                  (
                    cbData?.assetType === embLabels.HYBRID)))
            ) {
              let cb = {};
              cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
              cb.userId = 1;
              cb.componentIdx = CBComponentIdx;
              cb.componentName = cbData?.cbConfigData?.name;
              cb.componentType = "Circuit Breaker";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails?.[0];
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              let attributes = {
                name: cbData?.cbConfigData?.name,
                description: cbData?.cbConfigData?.description,
                motorized: cbData?.cbConfigData.motorized ? 1 : 0,
                contactor: cbData?.cbConfigData.contactor ? 1 : 0,
                loadCategory: cbData?.cbConfigData?.loadCategory,
                loadPriority: cbData?.cbConfigData?.loadPriority,
                Contactor_healthy_status_available: 0,
              };

              if (
                siteType === embLabels.GRID_CONNECTED &&
                cbData.assetType === embLabels.BESS &&
                !cbData?.uiData?.cbRequired
              ) {
                attributes.hardwired = cbData?.cbConfigData?.hardwired;
              }
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                // cbData?.cbConfigData?.motorized &&
                cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                "Hardwired"
              ) {
                attributes.type = "12";
              }
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                cbData?.assetType === embLabels.BESS &&
                cbData?.uiData?.contactor
              ) {
                attributes.type = "20";
                attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
              }

              if (!cbData?.cbConfigData?.motorized && !cbData?.uiData?.contactor) {
                attributes.type = "40"
              }
              if (cbData?.assetType === embLabels.HYBRID && clientType === embLabels.A2E_PROJECT && siteType === embLabels.GENSET_PVBESS_A2E) {
                attributes.type = "40"
              }
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                cbData?.assetType === embLabels.BESS &&
                !cbData?.uiData?.cbRequired
              ) {
                attributes.type = "40";
              }
              if (isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland) {
                if (cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired") {
                  attributes.type = "12";
                }


                if (!cbData?.uiData?.contactor && !cbData?.cbConfigData?.motorized) {
                  attributes.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributes.type = "40";
                }
                if(cbData?.uiData?.cbRequired && cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo==="Communicating"){
                    delete attributes.type;
                }

                if (cbData?.uiData?.contactor) {
                  attributes.type = "20";
                  attributes.Contactor_healthy_status_available =
                    cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
                }

              }
              cb.attributes = JSON.stringify(attributes);
              //cb values
              let communications = {};

              if (cbData?.assetType === embLabels.UTILITY) {
                communications = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };
              }
              if (cbData?.assetType === embLabels.GENSET) {
                communications = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };
              }
              if (cbData?.assetType === embLabels.BESS) {
                // her ethe code goes add pcu and mbms if()

                communications = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };
              }
              cb.connections.push(connections);
              cb.communications.push(communications);

              if (
                clientType === embLabels.A2E_PROJECT &&
                siteType === embLabels.GENSET_PVBESS_A2E &&
                (cbData?.assetType === embLabels.GENSET ||
                  cbData?.assetType === embLabels.HYBRID)
              ) {
                cb.communications = [];
              }
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              [embLabels.ISLANDABLE, embLabels.GRID_CONNECTED, embLabels.OFF_GRID].includes(siteType) &&
              cbData?.assetType === embLabels.BESS &&
              cbData?.uiData?.contactor && !cbData?.cbConfigData.motorized
            ) {
              let cb = {};
              cb.assetId =
                cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
              cb.userId = 1;
              cb.componentIdx = CRComponentIdx;
              cb.componentName = cbData?.contactorConfigData?.name;
              cb.componentType = "Contactor";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.contactorConfigData.cbAssetDetails[0];
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: CBComponentIdx,
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              let attributes = {
                name: cbData?.contactorConfigData?.name,
                description: cbData?.contactorConfigData?.description,
                loadCategory: cbData?.contactorConfigData?.loadCategory,
                loadPriority: cbData?.contactorConfigData?.loadPriority,
              };

              cb.attributes = JSON.stringify(attributes);

              //cb values
              let communications = {};

              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            //* for pvhybridization

            if (
              // siteType === embLabels.PV_HYBRIDIZATION ||
              cbData?.uiData?.pmRequired && cbData?.assetType === embLabels.BESS && !isDaasIec &&
              architectureType === embLabels.PV_GENSET_ATS
            ) {
              let cb = {};
              // cb.assetId = powerMeter?.assetId
              //   ? powerMeter?.assetId
              //   : cbData?.powerMeterData?.pmAsset?.assetId;
              // cb.userId = 1;
              // cb.componentIdx = PMComponentIdx;
              // cb.componentName = cbData?.powerMeterData?.name;
              // cb.componentType = "Power Meter";
              // cb.connections = [];
              // cb.communications = [];
              // cb.uiAttributes = JSON.stringify(cbData.uiData);
              cb.assetId = cbData?.powerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name !== "" ? cbData?.powerMeterData?.name : defaultPreFillData?.[0]?.["Power Meter"]?.nameGenset;
              cb.componentType = "Power Meter";
              cb.communications = [];
              cb.connections = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?.assetId;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name,
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: cbData?.powerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values
              let communications = {};
              communications = {
                ip: cbData?.powerMeterData?.ipAddress,
                subnetmask: cbData?.powerMeterData?.mask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                type: "Circuit Breaker",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              architectureType === embLabels.PV_GENSET_ATS &&
              cbData.uiData.existingPmRequired
            ) {
              let cb = {};
              cb.assetId = powerMeter?.assetId
                ? powerMeter?.assetId
                : cbData?.existingPowerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = "PM_50";
              cb.componentName = cbData?.existingPowerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = powerMeter?.assetId
                ? powerMeter
                : cbData?.existingPowerMeterData?.pmAsset;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.existingPowerMeterData?.name,
                description: cbData?.existingPowerMeterData?.description,
                powerMeterModbusId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values
              let communications = {};
              communications = {
                ip: cbData?.existingPowerMeterData?.ipAddress,
                subnetmask: cbData?.existingPowerMeterData?.mask,
                defaultGateway: cbData?.existingPowerMeterData?.gatewayAddress,
                modbusSlaveId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
                type: "Circuit Breaker",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            //* pv+bess(nr)
            if (
              siteType === embLabels.GRID_CONNECTED_GSX &&
              cbData.assetType === embLabels.UTILITY
            ) {
              // do nothing
            }

            if (((isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland)) && cbData?.assetType === embLabels.UTILITY) {
              let cb = {};
              // cb.assetId = powerMeter?.assetId
              //   ? powerMeter?.assetId
              //   : cbData?.powerMeterData?.pmAsset?.assetId;
              // cb.userId = 1;
              // cb.componentIdx = PMComponentIdx;
              // cb.componentName = cbData.powerMeterData.name??"PM_Utility";
              // cb.componentType = "Power Meter";
              // cb.connections = [];
              // cb.communications = [];
              cb.assetId = cbData?.powerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name !== "" ? cbData?.powerMeterData?.name : defaultPreFillData?.[0]?.["Power Meter"]?.nameGenset;
              cb.componentType = "Power Meter";
              cb.communications = [];
              cb.connections = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name,
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: cbData?.powerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};
              communications = {
                ip: cbData?.powerMeterData?.ipAddress,
                subnetmask: cbData?.powerMeterData?.mask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              siteType === embLabels.GRID_CONNECTED_GSX &&
              architectureType === embLabels.PV_BESS_NR &&
              cbData.assetType === embLabels.BESS
              // &&cbData.uiData.cbRequired
            ) {
              let cb = {};
              cb.assetId =
                cbData?.cbConfigData?.cbAssetDetails[0]?.assetId ?? 7;
              cb.userId = 1;
              cb.componentIdx = CBComponentIdx;
              cb.componentName = cbData?.cbConfigData?.name;
              cb.componentType = "Circuit Breaker";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              let attributes = {
                name: cbData?.cbConfigData?.name,
                description: cbData?.cbConfigData?.description,
                motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
                contactor: cbData?.cbConfigData?.contactor ? 1 : 0,
                loadCategory: cbData?.cbConfigData?.loadCategory,
                loadPriority: cbData?.cbConfigData?.loadPriority,
              };
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                // cbData?.cbConfigData?.motorized &&
                cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                "Hardwired"
              ) {
                attributes.type = "12";
              }
              cb.attributes = JSON.stringify(attributes);

              //cb values
              let communications = {
                ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                subnetmask:
                  cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                defaultGateway:
                  cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                modbusSlaveId:
                  cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                type: "Circuit Breaker",
              };

              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              (siteType === embLabels.GRID_CONNECTED_GSX &&
                architectureType === embLabels.PV_BESS_NR &&
                cbData.assetType === embLabels.BESS &&
                cbData.uiData.existingPmRequired) ||
              (projectKind?.isMgaasAnsiGrid &&
                cbData?.uiData.existingPmRequired)
            ) {
              let cb = {};
              cb.assetId = powerMeter?.assetId
                ? powerMeter?.assetId
                : cbData?.existingPowerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = "PM_50";
              cb.componentName = cbData?.existingPowerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = powerMeter?.assetId
                ? powerMeter
                : cbData?.existingPowerMeterData?.pmAsset
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.existingPowerMeterData?.name,
                description: cbData?.existingPowerMeterData?.description,
                powerMeterModbusId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values
              let communications = {};
              communications = {
                ip: cbData?.existingPowerMeterData?.ipAddress,
                subnetmask: cbData?.existingPowerMeterData?.mask,
                defaultGateway: cbData?.existingPowerMeterData?.gatewayAddress,
                modbusSlaveId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
                type: "Circuit Breaker",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              (siteType === embLabels.GRID_CONNECTED_GSX &&
                architectureType === embLabels.PV_BESS_NR &&
                cbData?.assetType === embLabels.BESS &&
                cbData?.uiData.pmRequired) ||
              (isMgaasAnsi && cbData?.assetType === embLabels.BESS && cbData?.uiData.pmRequired) ||
              ((projectKind?.isMgaasIec || projectKind?.isMGaaSETO || projectKind?.isNMGaaSETO || projectKind?.isDaasIecIsland) &&
                cbData?.assetType === embLabels.BESS && cbData?.uiData.pmRequired)
            ) {
              let cb = {};
              cb.assetId = cbData?.powerMeterData?.pmAsset?.assetId ? cbData?.powerMeterData?.pmAsset?.assetId
                : powerMeter?.assetId ? powerMeter?.assetId : 153;

              // cb.assetId = 153
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name || "PM_BESS";
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?.assetId ? cbData?.powerMeterData?.pmAsset
                : powerMeter;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: "PM_BESS",
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: "255",
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};
              communications = {
                ip: cbData?.powerMeterData?.ipAddress,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                subnetmask: cbData?.powerMeterData?.mask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);

              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }
            // Adding PM data for Utility only for ANSI projects here
            if ((isMgaasAnsi || isDaasAnsi || isDaasEto || isDaasIec) && cbData?.assetType === embLabels.UTILITY && cbData?.uiData.pmRequired) {

              let cb = {};
              cb.assetId =
                cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name || `PM_${cbData.assetType}`,
                description: cbData?.powerMeterData?.description || "",
                powerMeterModbusId:
                  cbData?.powerMeterData?.powerMeterModbusId || "",
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};

              communications = {
                ip: cbData?.powerMeterData?.ipAddress ?? defaultPreFillData?.[0]?.["Power Meter"]?.[`ipAddress_PM_${cbData?.assetType}`],
                subnetmask: cbData?.powerMeterData?.mask ?? defaultPreFillData?.[0]?.["Power Meter"]?.subnetMask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress ?? defaultPreFillData?.[0]?.["Power Meter"]?.defaultGateway,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId ?? defaultPreFillData?.[0]?.["Power Meter"]?.[`modbusId_PM_${cbData?.assetType}`],
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }
            //*for grid_connected
            if ((isMgaasIecGrid || isMGaaSETOGrid || isNMGaaSETOGrid || isMGaaSETOGensetPvHybrid || isNMGaaSETOGensetPvHybrid) &&
              cbData?.assetType === embLabels.UTILITY
              && cbData?.uiData?.pmRequired
            ) {

              let cb = {};
              cb.assetId =
                cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name || `PM_${cbData?.assetType}`,
                description: cbData?.powerMeterData?.description || "",
                powerMeterModbusId:
                  cbData?.powerMeterData?.powerMeterModbusId || "",
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};

              communications = {
                ip: cbData?.powerMeterData?.ipAddress ?? defaultPreFillData?.[0]?.["Power Meter"]?.[`ipAddress_PM_${cbData?.assetType}`],
                subnetmask: cbData?.powerMeterData?.mask ?? defaultPreFillData?.[0]?.["Power Meter"]?.subnetMask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress ?? defaultPreFillData?.[0]?.["Power Meter"]?.defaultGateway,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId ?? defaultPreFillData?.[0]?.["Power Meter"]?.[`modbusId_PM_${cbData?.assetType}`],
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;

              //*cb values utility
            }

            if (
              (clientType === embLabels.A2E_PROJECT &&
                siteType === embLabels.GENSET_PVBESS_A2E &&
                cbData.assetType === embLabels.GENSET) ||
              (((isMgaasAnsiIsland || isMgaasAnsiOffGrid) || projectKind?.isDaasIecIsland || isDaasAnsiIsland || isDaasEtoIsland) &&
                cbData.assetType === embLabels.GENSET &&
                cbData.uiData.pmRequired) ||
              (cbData.assetType === embLabels.GENSET && (isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland || isMGaaSETOGensetPvHybrid || isNMGaaSETOGensetPvHybrid || isMgaasIecOffGrid || isMassEtoOffGrid) && cbData.uiData.pmRequired)
            ) {
              let cbNew = {};
              cbNew.assetId = cbData?.powerMeterData?.pmAsset?.assetId;
              cbNew.userId = 1;
              cbNew.componentIdx = PMComponentIdx;
              cbNew.componentName = cbData?.powerMeterData?.name !== "" ? cbData?.powerMeterData?.name : defaultPreFillData?.[0]?.["Power Meter"]?.nameGenset;
              cbNew.componentType = "Power Meter";
              cbNew.communications = [];
              cbNew.connections = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset;
              cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
              let attributesnew = {
                name: cbData?.powerMeterData?.name,
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: cbData?.powerMeterData?.powerMeterModbusId,
              };

              cbNew.attributes = JSON.stringify(attributesnew);
              let newConnection = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              //* cb values

              // let communicationsnew = {
              //   ip: cbData?.powerMeterData?.ipAddress,
              //   subnetmask: cbData?.powerMeterData?.mask,
              //   defaultGateway: cbData?.powerMeterData?.gatewayAddress,
              //   modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
              //   type: "Power Meter",
              // };
              let communicationsnew = {
                ip: cbData?.powerMeterData?.ipAddress ?? defaultPreFillData?.[0]?.["Power Meter"]?.[`ipAddress_PM_${cbData?.assetType}`],
                subnetmask: cbData?.powerMeterData?.mask ?? defaultPreFillData?.[0]?.["Power Meter"]?.subnetMask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress ?? defaultPreFillData?.[0]?.["Power Meter"]?.defaultGateway,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId ?? defaultPreFillData?.[0]?.["Power Meter"]?.[`modbusId_PM_${cbData?.assetType}`],
                type: "Power Meter",
              };

              cbNew.communications.push(communicationsnew);
              cbNew.connections.push(newConnection);
              arrayComponent.push(cbNew);
            }

            assetI = assetI + 1;

            break;
          case embLabels.INVERTER:
            let connectionList = [];

            if (cbData?.pv === 1) {
              CBComponentIdx = "CB_40";
              CRComponentIdx = "Contactor_40";
              PMComponentIdx = "PM_40";
              PVDetails?.pvset1Data?.map((data, key) => {
                let asset = {};
                if (cbData?.assetType === embLabels.INVERTER) {
                  asset.componentType = "Inverter";
                }
                asset.userId = 1;
                asset.componentIdx = `ASSET_${padNumberFormat(assetI)}`;
                 asset.componentId = PVDetails?.pvset1Data[key]?.componentId ?? null;
                asset.uuid = PVDetails?.pvset1Data[key]?.uuid ?? null;
                asset.componentName = PVDetails?.pvset1Data[key]?.name;
                asset.externalId = PVDetails?.pvset1Data[key]?.pvGsxExternalId
                  ? PVDetails?.pvset1Data[key]?.pvGsxExternalId
                  : gsxExternalId?.utilityExternalId;
                if (PVDetails?.pvset1Data?.[key]?.assetDetails?.[0] !== undefined) {
                  asset.assetId =
                    PVDetails?.pvset1Data[key]?.assetDetails[0]?.assetId;
                } else {
                  asset.assetId = 4;
                }

                asset.connections = [];
                asset.communications = [];
                cbData.uiData.pv = 1;
                cbData.uiData.groupName = PVDetails?.pvset1Data[key]?.groupName;
                cbData.uiData.configured = PVDetails?.pvset1Data[key]?.status;
                cbData.uiData.assetInfo = PVDetails?.pvset1Data[key]?.assetDetails[0];
                asset.uiAttributes = JSON.stringify(cbData?.uiData);
                const configured = cbData?.uiData?.configured === true;
                if (componentJson === null) return;
                componentJson.deploymentReady = !!componentJson.deploymentReady && configured;
                // componentJson.deploymentReady =
                //   componentJson?.deploymentReady && cbData?.uiData?.configured
                //     ? true
                //     : false;
                let assetConnections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let assetAttributes = {
                  name: PVDetails?.pvset1Data[key]?.name,
                  description: PVDetails?.pvset1Data[key]?.description,
                  max_power: PVDetails?.pvset1Data[key]?.max_power,
                  groupName: PVDetails?.pvset1Data[key]?.groupName,
                  group_max_power: PVDetails?.pvset1Data[key]?.group_max_power,
                };
                asset.attributes = JSON.stringify(assetAttributes);

                if (
                  [
                    embLabels.ISLANDABLE,
                    embLabels.OFF_GRID,
                    embLabels.PV_HYBRIDIZATION,
                    embLabels.GRID_CONNECTED_GSX,
                    embLabels.GRID_CONNECTED,
                  ].includes(siteType) ||
                  architectureType === embLabels.PV_GENSET_ATS
                ) {
                  asset.connections.push(assetConnections);
                }

                //* no communication for hardwired

                let assetCommunications;

                if (
                  PVDetails?.pvset1Data?.[key]?.assetDetails.length &&
                  PVDetails?.pvset1Data?.[key]?.assetDetails[0].assetInfo ===
                  "Hardwired"
                ) {
                  assetCommunications = {};
                } else if (
                  PVDetails?.pvset1Data?.[key]?.assetDetails?.length &&
                  PVDetails?.pvset1Data?.[key]?.assetDetails?.[0]?.assetInfo ===
                  embLabels.SERIAL
                ) {
                  assetCommunications = {
                    ip: "",
                    subnetmask: "",
                    defaultGateway: "",
                    modbusSlaveId: PVDetails?.pvset1Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                } else {
                  assetCommunications = {
                    ip: PVDetails?.defaultPVIpPreFillBackUp[key],
                    subnetmask: PVDetails?.pvset1Data?.[key]?.subnetmask,
                    defaultGateway: PVDetails?.pvset1Data?.[key]?.defaultGateway,
                    modbusSlaveId: PVDetails?.pvset1Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                }
                asset.communications.push(assetCommunications);
                arrayComponent.push(asset);
                let connectionNew = {
                  componentIdx: `ASSET_${padNumberFormat(assetI)}`,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                connectionList.push(connectionNew);
                assetI = assetI + 1;
                return null;
              });

              if (
                siteType === embLabels.ISLANDABLE ||
                siteType === embLabels.OFF_GRID ||
                (siteType === embLabels.GRID_CONNECTED
                  //  && cbData?.uiData?.cbRequired
                ) ||
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR
                  // &&cbData.uiData.cbRequired &&cbData?.uiData?.cbRequired
                ) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS
                  // &&cbData?.uiData?.cbRequired
                ) ||
                siteType === embLabels.PV_HYBRIDIZATION
              ) {
                let cbNew = {};

                cbNew.assetId =
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CBComponentIdx;
                cbNew.componentName = cbData?.cbConfigData?.name;
                cbNew.componentType = "Circuit Breaker";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);

                let attributesnew = {
                  name: cbData?.cbConfigData?.name,
                  description: cbData?.cbConfigData?.description,
                  motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
                  contactor: cbData?.cbConfigData?.contactor ? 1 : 0,
                  loadCategory: cbData?.cbConfigData?.loadCategory,
                  loadPriority: cbData?.cbConfigData?.loadPriority,
                  Contactor_healthy_status_available: 0,
                };
                if (
                  siteType === embLabels.GRID_CONNECTED &&
                  !cbData?.uiData?.cbRequired
                ) {
                  attributesnew.hardwired = cbData?.cbConfigData?.hardwired;
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  // cbData?.cbConfigData?.motorized &&
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                  "Hardwired"
                ) {
                  attributesnew.type = "12";
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.contactor
                ) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }


                if (!cbData?.cbConfigData?.motorized && !cbData?.uiData?.contactor) {
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                if (isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland) {
                  if (cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired") {
                    attributesnew.type = "12";
                  }
                  if (cbData?.uiData?.contactor) {
                    attributesnew.type = "20";
                    attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                  }
                  if (!cbData?.uiData?.contactor && !cbData?.cbConfigData?.motorized) {
                    attributesnew.type = "40"
                  }
                  if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                    attributesnew.type = "40";
                  }
                }
                cbNew.attributes = JSON.stringify(attributesnew);
                // const communicationsnew = generateIfeValues("CB_40", cbData);
                let communicationsnew = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };

                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                [embLabels.ISLANDABLE, embLabels.GRID_CONNECTED, embLabels.OFF_GRID,].includes(siteType) &&
                cbData?.uiData?.contactor && !cbData.cbConfigData.motorized
              ) {
                let cbNew = {};

                cbNew.assetId =
                  cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                // Create a shallow copy of uiData to avoid circular reference
                const uiDataForStringify = { ...cbData.uiData };
                // Only include serializable properties from assetInfo if needed
                if (cbData.contactorConfigData?.cbAssetDetails?.[0]) {
                  const assetDetails = cbData.contactorConfigData.cbAssetDetails[0];
                  uiDataForStringify.assetInfo = {
                    assetId: assetDetails.assetId,
                    assetName: assetDetails.assetName,
                    manufacturer: assetDetails.manufacturer,
                    communicationModel: assetDetails.communicationModel,
                    assetInfo: assetDetails.assetInfo
                  };
                }
                cbNew.uiAttributes = JSON.stringify(uiDataForStringify);

                let connections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                cbNew.connections.push(connections);
                cbNew.communications.push({});

                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.ISLANDABLE_GSX && architectureType === embLabels.PV_GENSET_ATS) ||
                (siteType === embLabels.GRID_CONNECTED_GSX && architectureType === embLabels.PV_BESS_NR && cbData.uiData.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED && cbData.uiData.pmRequired) ||
                (siteType === embLabels.PV_HYBRIDIZATION && cbData.uiData.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED && projectTypeValue === "MGaaS ANSI" && cbData.uiData.pmRequired) ||
                ((siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) && projectTypeValue === "MGaaS ANSI" && cbData.uiData.pmRequired) ||
                ((projectKind?.isMgaasIecIsland || isNMGaaSETOIsland || projectKind?.isMGaaSETOIsland || projectKind?.isMgaasAnsiOffGrid || projectKind?.isMgaasIecOffGrid || projectKind?.isMassEtoOffGrid) && cbData.uiData.pmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.powerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name ?? defaultPreFillData?.[0]?.["Power Meter"]?.namePV;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                // cbNew.connections = [];
                cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                let connections = {
                  componentIdx: "ASSET_" + padNumberFormat(assetI),
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                // cbNew.connections.push(connections)
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData?.existingPmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" &&
                  cbData?.uiData?.existingPmRequired) ||
                ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland || isNMGaaSETOIsland) && cbData.uiData.existingPmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.existingPowerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = "PM_51";
                cbNew.componentName = cbData?.existingPowerMeterData?.name;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.existingPowerMeterData?.pmAsset ?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.existingPowerMeterData?.name,
                  description: cbData?.existingPowerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.existingPowerMeterData?.ipAddress,
                  subnetmask: cbData?.existingPowerMeterData?.mask,
                  defaultGateway:
                    cbData?.existingPowerMeterData?.gatewayAddress,
                  modbusSlaveId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                siteType === embLabels.ISLANDABLE_GSX &&
                architectureType === embLabels.PV_GENSET_ATS &&
                cbData?.uiData?.existingPmRequired
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.existingPowerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = "PM_51";
                cbNew.componentName = cbData?.existingPowerMeterData?.name;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.existingPowerMeterData?.pmAsset ?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.existingPowerMeterData?.name,
                  description: cbData?.existingPowerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.existingPowerMeterData?.ipAddress,
                  subnetmask: cbData?.existingPowerMeterData?.mask,
                  defaultGateway:
                    cbData?.existingPowerMeterData?.gatewayAddress,
                  modbusSlaveId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
            } else if (cbData?.pv === 2) {
              CBComponentIdx = "CB_41";
              CRComponentIdx = "Contactor_41";
              PMComponentIdx = "PM_41";
              PVDetails?.pvset2Data?.map((data, key) => {
                let asset = {};
                if (cbData?.assetType === embLabels.INVERTER) {
                  asset.componentType = "Inverter";
                }
                asset.userId = 1;
                asset.componentIdx = "ASSET_" + padNumberFormat(assetI);
                asset.componentId = PVDetails?.pvset2Data[key]?.componentId ?? null;
                asset.uuid = PVDetails?.pvset2Data[key]?.uuid ?? null;
                asset.componentName = PVDetails?.pvset2Data[key]?.name;
                asset.externalId = PVDetails?.pvset2Data[key]?.pvGsxExternalId
                  ? PVDetails?.pvset2Data[key]?.pvGsxExternalId
                  : gsxExternalId?.utilityExternalId;
                if (PVDetails?.pvset2Data?.[key]?.assetDetails?.[0] !== undefined) {
                  asset.assetId =
                    PVDetails?.pvset2Data[key]?.assetDetails?.[0]?.assetId;
                } else {
                  asset.assetId = 4;
                }
                asset.connections = [];
                asset.communications = [];
                cbData.uiData.pv = 2;
                cbData.uiData.groupName = PVDetails?.pvset2Data[key]?.groupName;
                cbData.uiData.configured = PVDetails?.pvset2Data[key]?.status;
                cbData.uiData.assetInfo = PVDetails?.pvset2Data[key]?.assetDetails[0];
                asset.uiAttributes = JSON.stringify(cbData?.uiData);
                componentJson.deploymentReady =
                  componentJson.deploymentReady && cbData?.uiData?.configured
                    ? true
                    : false;
                let assetConnections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let assetAttributes = {
                  name: PVDetails?.pvset2Data[key]?.name,
                  description: PVDetails?.pvset2Data[key]?.description,
                  max_power: PVDetails?.pvset2Data[key]?.max_power,
                  groupName: PVDetails?.pvset2Data[key]?.groupName,
                  group_max_power: PVDetails?.pvset2Data[key]?.group_max_power,
                };
                asset.attributes = JSON.stringify(assetAttributes);
                if (
                  siteType === embLabels.ISLANDABLE ||
                  siteType === embLabels.OFF_GRID ||
                  siteType === embLabels.PV_HYBRIDIZATION ||
                  siteType === embLabels.GRID_CONNECTED_GSX ||
                  siteType === embLabels.GRID_CONNECTED ||
                  (siteType === embLabels.ISLANDABLE_GSX &&
                    architectureType === embLabels.PV_GENSET_ATS &&
                    defaultPreFillData[1].mode === "FUEL_SAVER")
                ) {
                  asset.connections.push(assetConnections);
                }

                //* no communication for hardwired

                let assetCommunications;

                if (
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.length &&
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.[0]?.assetInfo ===
                  "Hardwired"
                ) {
                  assetCommunications = {};
                } else if (
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.length &&
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.[0]?.assetInfo === embLabels.SERIAL
                ) {
                  assetCommunications = {
                    ip: '',
                    subnetmask: "",
                    defaultGateway: "",
                    modbusSlaveId: PVDetails?.pvset2Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                } else {
                  let index = PVDetails?.pvset1Data?.length + key
                  assetCommunications = {
                    ip: PVDetails?.defaultPVIpPreFillBackUp?.[index],
                    subnetmask: PVDetails?.pvset2Data?.[key]?.subnetmask,
                    defaultGateway: PVDetails?.pvset2Data?.[key]?.defaultGateway,
                    modbusSlaveId: PVDetails?.pvset2Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                }

                asset.communications.push(assetCommunications);
                arrayComponent.push(asset);
                let connectionNew = {
                  componentIdx: "ASSET_" + padNumberFormat(assetI),
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                connectionList.push(connectionNew);
                assetI = assetI + 1;
                return null;
              });
              //conncetion made for daas ansi

              if (
                siteType === embLabels.ISLANDABLE ||
                siteType === embLabels.OFF_GRID ||
                siteType === embLabels.PV_HYBRIDIZATION ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue !== "MGaaS ANSI") ||
                (siteType === embLabels.GRID_CONNECTED_GSX
                  // &&cbData.uiData.cbRequired
                ) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI")
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CBComponentIdx;
                cbNew.componentName = cbData?.cbConfigData?.name;
                cbNew.componentType = "Circuit Breaker";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.cbConfigData?.name,
                  description: cbData?.cbConfigData?.description,
                  motorized: cbData?.cbConfigData.motorized ? 1 : 0,
                  contactor: cbData?.cbConfigData.contactor ? 1 : 0,
                  loadCategory: cbData?.cbConfigData?.loadCategory,
                  loadPriority: cbData?.cbConfigData?.loadPriority,
                  Contactor_healthy_status_available: 0,
                };
                if (
                  siteType === embLabels.GRID_CONNECTED &&
                  !cbData?.uiData.cbRequired
                ) {
                  attributesnew.hardwired = cbData?.cbConfigData?.hardwired;
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  // cbData?.cbConfigData?.motorized &&
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                  "Hardwired"
                ) {
                  attributesnew.type = "12";
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.contactor
                ) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }

                if (!cbData?.cbConfigData?.motorized && !cbData?.uiData?.contactor) {
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                if (isMgaasIecIsland) {
                  if (cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired") {
                    attributesnew.type = "12";
                  }
                  if (cbData?.uiData?.contactor) {
                    attributesnew.type = "20";
                    attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                  }
                  if (!cbData?.uiData?.contactor && !cbData?.cbConfigData?.motorized) {
                    attributesnew.type = "40"
                  }
                  if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                    attributesnew.type = "40";
                  }
                }
                cbNew.attributes = JSON.stringify(attributesnew);

                let communicationsnew = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };

                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                [embLabels.ISLANDABLE, embLabels.GRID_CONNECTED, embLabels.OFF_GRID,].includes(siteType) &&
                cbData?.uiData?.contactor && !cbData.cbConfigData.motorized
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.contactorConfigData.cbAssetDetails[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                // Create a shallow copy of uiData to avoid circular reference
                const uiDataForStringify = { ...cbData.uiData };
                // Only include serializable properties from assetInfo if needed
                if (cbData.contactorConfigData?.cbAssetDetails?.[0]) {
                  const assetDetails = cbData.contactorConfigData.cbAssetDetails[0];
                  uiDataForStringify.assetInfo = {
                    assetId: assetDetails.assetId,
                    assetName: assetDetails.assetName,
                    manufacturer: assetDetails.manufacturer,
                    communicationModel: assetDetails.communicationModel,
                    assetInfo: assetDetails.assetInfo
                  };
                }
                cbNew.uiAttributes = JSON.stringify(uiDataForStringify);
                let connections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };

                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                //cbNew values
                let communications = {};

                cbNew.connections.push(connections);
                cbNew.communications.push(communications);
                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.PV_HYBRIDIZATION &&
                  cbData?.uiData.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" && cbData.uiData.pmRequired) ||
                ((siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) &&
                  projectTypeValue === "MGaaS ANSI" && cbData.uiData.pmRequired) ||
                ((projectKind?.isMgaasIecIsland || isNMGaaSETOIsland || projectKind?.isMGaaSETOIsland) && cbData.uiData.pmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.powerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name ?? defaultPreFillData?.[0]?.["Power Meter"]?.namePV;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
            } else if (cbData?.pv === 3) {
              CBComponentIdx = "CB_42";
              CRComponentIdx = "Contactor_42";
              PMComponentIdx = "PM_42";
              PVDetails?.pvset3Data?.map((data, key) => {
                let asset = {};
                if (cbData?.assetType === embLabels.INVERTER) {
                  asset.componentType = "Inverter";
                }
                asset.userId = 1;
                asset.componentIdx = "ASSET_" + padNumberFormat(assetI);
                asset.componentName = PVDetails?.pvset3Data?.[key]?.name;
                 asset.componentId = PVDetails?.pvset3Data[key]?.componentId ?? null;
                 asset.uuid = PVDetails?.pvset3Data[key]?.uuid ?? null;
                asset.externalId = PVDetails?.pvset3Data?.[key]?.pvGsxExternalId
                  ? PVDetails?.pvset3Data?.[key]?.pvGsxExternalId
                  : gsxExternalId?.utilityExternalId;
                if (PVDetails?.pvset3Data?.[key]?.assetDetails?.[0] !== undefined) {
                  asset.assetId =
                    PVDetails?.pvset3Data?.[key]?.assetDetails?.[0]?.assetId;
                } else {
                  asset.assetId = 4;
                }
                asset.connections = [];
                asset.communications = [];
                cbData.uiData.pv = 3;
                cbData.uiData.groupName = PVDetails?.pvset3Data?.[key]?.groupName;
                cbData.uiData.configured = PVDetails?.pvset3Data?.[key]?.status;
                cbData.uiData.assetInfo = PVDetails?.pvset3Data?.[key]?.assetDetails[0];
                asset.uiAttributes = JSON.stringify(cbData?.uiData);
                componentJson.deploymentReady =
                  componentJson.deploymentReady && cbData?.uiData?.configured
                    ? true
                    : false;
                let assetConnections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let assetAttributes = {
                  name: PVDetails?.pvset3Data?.[key]?.name,
                  description: PVDetails?.pvset3Data?.[key]?.description,
                  max_power: PVDetails?.pvset3Data?.[key]?.max_power,
                  groupName: PVDetails?.pvset3Data?.[key]?.groupName,
                  group_max_power: PVDetails?.pvset3Data?.[key]?.group_max_power,
                };
                asset.attributes = JSON.stringify(assetAttributes);

                // if (
                //   siteType === embLabels.ISLANDABLE ||
                //   siteType === embLabels.GRID_CONNECTED_GSX
                // ) {
                //   asset.connections.push(assetConnections);
                // }

                if (
                  siteType === embLabels.ISLANDABLE ||
                  siteType === embLabels.OFF_GRID ||
                  siteType === embLabels.PV_HYBRIDIZATION ||
                  siteType === embLabels.GRID_CONNECTED_GSX ||
                  siteType === embLabels.GRID_CONNECTED ||
                  (siteType === embLabels.ISLANDABLE_GSX &&
                    architectureType === embLabels.PV_GENSET_ATS &&
                    defaultPreFillData[1].mode === "FUEL_SAVER")
                ) {
                  asset.connections.push(assetConnections);
                }
                //* no communication for hardwired

                let assetCommunications;

                if (
                  PVDetails?.pvset3Data[key].assetDetails.length &&
                  PVDetails?.pvset3Data[key].assetDetails[0].assetInfo ===
                  "Hardwired"
                ) {
                  assetCommunications = {};
                } else if (
                  PVDetails?.pvset3Data[key].assetDetails.length &&
                  PVDetails?.pvset3Data[key].assetDetails[0].assetInfo === embLabels.SERIAL
                ) {
                  assetCommunications = {
                    ip: '',
                    subnetmask: "",
                    defaultGateway: "",
                    modbusSlaveId: PVDetails?.pvset3Data[key].modbusSlaveId,
                    type: "INVERTER",
                  };
                } else {
                  let index = PVDetails?.pvset1Data.length + PVDetails?.pvset2Data.length + key
                  assetCommunications = {
                    ip: PVDetails?.defaultPVIpPreFillBackUp?.[index],
                    subnetmask: PVDetails?.pvset3Data?.[key]?.subnetmask,
                    defaultGateway: PVDetails?.pvset3Data?.[key]?.defaultGateway,
                    modbusSlaveId: PVDetails?.pvset3Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                }
                asset.communications.push(assetCommunications);
                arrayComponent.push(asset);
                let connectionNew = {
                  componentIdx: "ASSET_" + padNumberFormat(assetI),
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                connectionList.push(connectionNew);
                assetI = assetI + 1;
                return null;
              });


              if (
                siteType === embLabels.ISLANDABLE ||
                siteType === embLabels.OFF_GRID ||
                siteType === embLabels.PV_HYBRIDIZATION ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue !== "MGaaS ANSI") ||
                (siteType === embLabels.GRID_CONNECTED_GSX
                  // &&cbData.uiData.cbRequired
                ) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI")
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CBComponentIdx;
                cbNew.componentName = cbData?.cbConfigData?.name;
                cbNew.componentType = "Circuit Breaker";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.cbConfigData?.name,
                  description: cbData?.cbConfigData?.description,
                  motorized: cbData?.cbConfigData.motorized ? 1 : 0,
                  contactor: cbData?.cbConfigData.contactor ? 1 : 0,
                  loadCategory: cbData?.cbConfigData?.loadCategory,
                  loadPriority: cbData?.cbConfigData?.loadPriority,
                  Contactor_healthy_status_available: 0
                };
                if (
                  siteType === embLabels.GRID_CONNECTED &&
                  !cbData.uiData.cbRequired
                ) {
                  attributesnew.hardwired = cbData?.cbConfigData?.hardwired;
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  // cbData?.cbConfigData?.motorized &&
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                  "Hardwired"
                ) {
                  attributesnew.type = "12";
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.contactor
                ) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }

                if (!cbData?.cbConfigData?.motorized && !cbData?.uiData?.contactor) {
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                if (isMgaasIecIsland || isNMGaaSETOIsland) {
                  if (cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired") {
                    attributesnew.type = "12";
                  }
                  if (cbData?.uiData?.contactor) {
                    attributesnew.type = "20";
                    attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                  }
                  if (!cbData?.uiData?.contactor && !cbData?.cbConfigData?.motorized) {
                    attributesnew.type = "40"
                  }
                  if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                    attributesnew.type = "40";
                  }
                }
                cbNew.attributes = JSON.stringify(attributesnew);

                let communicationsnew = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };

                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
              if (
                [embLabels.ISLANDABLE, embLabels.GRID_CONNECTED, embLabels.OFF_GRID,].includes(siteType) &&
                cbData?.uiData?.contactor && !cbData.cbConfigData.motorized
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                // Create a shallow copy of uiData to avoid circular reference
                const uiDataForStringify = { ...cbData.uiData };
                // Only include serializable properties from assetInfo if needed
                if (cbData.contactorConfigData?.cbAssetDetails?.[0]) {
                  const assetDetails = cbData.contactorConfigData.cbAssetDetails[0];
                  uiDataForStringify.assetInfo = {
                    assetId: assetDetails.assetId,
                    assetName: assetDetails.assetName,
                    manufacturer: assetDetails.manufacturer,
                    communicationModel: assetDetails.communicationModel,
                    assetInfo: assetDetails.assetInfo
                  };
                }
                cbNew.uiAttributes = JSON.stringify(uiDataForStringify);
                let connections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };

                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                //cbNew values
                let communications = {};

                cbNew.connections.push(connections);
                cbNew.communications.push(communications);
                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData.pmRequired) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData.pmRequired) ||
                (siteType === embLabels.PV_HYBRIDIZATION &&
                  cbData?.uiData.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" && cbData.uiData.pmRequired) ||
                ((siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) &&
                  projectTypeValue === "MGaaS ANSI" && cbData.uiData.pmRequired) ||
                ((projectKind?.isMgaasIecIsland || isNMGaaSETOIsland || projectKind?.isMGaaSETOIsland) && cbData.uiData.pmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.powerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name ?? defaultPreFillData?.[0]?.["Power Meter"]?.namePV;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
            }

            break;

          default:
            break;
        }

      }
      return null;

    });

    //* load

    let loadCBI = 50;
    CBLoadList.map((cbData, key) => {
      // if(!cbData) return;
      let load = {};
      load.assetId = 6;
      load.userId = 1;
      let CRComponentIdx = `Contactor_${loadCBI}`
      load.componentIdx = `ASSET_${padNumberFormat(assetI)}`;
      load.componentId = cbData?.componentId ?? null;
      load.uuid = cbData?.uuid ?? null
      load.componentName = cbData?.configData?.name;
      load.componentType = "Load";
      load.connections = [];
      load.communications = [];
      load.uiAttributes = JSON.stringify(cbData?.uiData);
      if (
        [
          embLabels.ISLANDABLE,
          embLabels.GRID_CONNECTED,
          embLabels.OFF_GRID,
          embLabels.GENSET_PVBESS_A2E,
        ].includes(siteType)
      ) {
        componentJson.deploymentReady =
          componentJson.deploymentReady && cbData?.uiData?.configured
            ? true
            : false;
      }
      if (
        siteType === embLabels.PV_HYBRIDIZATION ||
        architectureType === embLabels.PV_GENSET_ATS
      ) {
        componentJson.deploymentReady =
          componentJson.deploymentReady === true ? true : false;
      }

      let connectionsLoad = {
        componentIdx: "CB_" + loadCBI,
        endpointIdX: "1",
        connectionType: "electrical_connection",
      };
      let loadattributes = {
        name: cbData?.configData?.name,
        description: cbData?.configData?.description,
        maximum_available_power: cbData?.configData?.maximum_available_power,
      };
      load.attributes = JSON.stringify(loadattributes);

      if (
        siteType === embLabels.GRID_CONNECTED_GSX ||
        siteType === embLabels.ISLANDABLE ||
        siteType === embLabels.OFF_GRID ||
        siteType === embLabels.GENSET_PVBESS_A2E ||
        siteType === embLabels.GRID_CONNECTED ||
        siteType === embLabels.PV_HYBRIDIZATION ||
        (siteType === embLabels.ISLANDABLE_GSX &&
          defaultPreFillData[1].mode === "FUEL_SAVER")
      ) {
        load.connections.push(connectionsLoad);
      }

      arrayComponent.push(load);

      if ((((siteType === embLabels.ISLANDABLE || siteType === embLabels.OFF_GRID) || (siteType === embLabels.GRID_CONNECTED && isExportOptimization)) && (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) && cbData.uiData.contactor) {
        let cbNew = {};
        cbNew.assetId =
          cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
        cbNew.userId = 1;
        cbNew.componentIdx = CRComponentIdx;
        cbNew.componentName = cbData?.contactorConfigData?.name;
        cbNew.componentType = "Contactor";
        cbNew.connections = [];
        cbNew.communications = [];
        // Create a shallow copy of uiData to avoid circular reference
        const uiDataForStringify = { ...cbData.uiData };
        // Only include serializable properties from assetInfo if needed
        if (cbData.contactorConfigData?.cbAssetDetails?.[0]) {
          const assetDetails = cbData.contactorConfigData.cbAssetDetails[0];
          uiDataForStringify.assetInfo = {
            assetId: assetDetails.assetId,
            assetName: assetDetails.assetName,
            manufacturer: assetDetails.manufacturer,
            communicationModel: assetDetails.communicationModel,
            assetInfo: assetDetails.assetInfo
          };
        }
        cbNew.uiAttributes = JSON.stringify(uiDataForStringify);
        let connections = {
          componentIdx: "CB_" + loadCBI,
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };

        let attributes = {
          name: cbData?.contactorConfigData?.name,
          description: cbData?.contactorConfigData?.description,
          loadCategory: cbData?.contactorConfigData?.loadCategory,
          loadPriority: cbData?.contactorConfigData?.loadPriority,
        };

        cbNew.attributes = JSON.stringify(attributes);

        //cbNew values
        let communications = {};

        cbNew.connections.push(connections);
        cbNew.communications.push(communications);
        arrayComponent.push(cbNew);
      }
      if (
        (siteType === embLabels.GRID_CONNECTED_GSX &&
          (projectTypeValue === "DaaS ANSI" || projectTypeValue === "DaaS ETO")) ||
        siteType === embLabels.ISLANDABLE ||
        siteType === embLabels.OFF_GRID ||
        (siteType === embLabels.ISLANDABLE_GSX &&
          defaultPreFillData[1].mode === "FUEL_SAVER") ||
        (siteType === embLabels.GRID_CONNECTED &&
          projectTypeValue === "MGaaS ANSI") ||
        (siteType === embLabels.GRID_CONNECTED || siteType === embLabels.PV_HYBRIDIZATION &&
          (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) || isDaasIecGrid
      ) {
        let cb = {};

        cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
        cb.userId = 1;
        cb.componentIdx = `CB_${loadCBI}`;
        cb.componentName = cbData?.cbConfigData?.name;
        cb.componentType = "Circuit Breaker";
        cb.connections = [];
        cb.communications = [];
        cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails?.[0];
        cb.uiAttributes = JSON.stringify(cbData?.uiData);
        let connectionsCb = {
          componentIdx: "ASSET_" + padNumberFormat(assetI),
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };

        //* copying cb values

        // let communications = {
        //   ip: cbData.cbConfigData?.cbCommunicationData?.ipaddress,
        //   subnetmask: cbData.cbConfigData?.cbCommunicationData?.subnetmask,
        //   defaultGateway:
        //     cbData.cbConfigData?.cbCommunicationData?.defaultGateway,
        //   modbusSlaveId:
        //     cbData.cbConfigData?.cbCommunicationData?.modbusSlaveId,
        //   type: "Circuit Breaker",
        // };
        let communications = {}
        if ((!isExportOptimization && isMgaasIecGrid) || isDaasAnsiGrid || isDaasEtoGrid || (!isExportOptimization && isMgaasAnsiGrid) || (!isExportOptimization && (isMGaaSETOGrid || isNMGaaSETOGrid)) || isMGaaSETOGensetPvHybrid || isNMGaaSETOGensetPvHybrid) {
          communications = {
            ip: "",
            subnetmask: "",
            defaultGateway: "",
            modbusSlaveId: "",
            type: "Circuit Breaker",
          };
        } else if (cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired") {
          communications = {
            ip: "",
            subnetmask: "",
            defaultGateway: "",
            modbusSlaveId: "",
            type: "Circuit Breaker",
          };
        } else {
          if ((isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland) && cbData.uiData.cbRequired == false) {
            communications = {
              ip: "",
              subnetmask: "",
              defaultGateway: "",
              modbusSlaveId: "",
              type: "Circuit Breaker",
            };
          } else {
            communications = {
              ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
              subnetmask: cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
              defaultGateway:
                cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
              modbusSlaveId:
                cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
              type: "Circuit Breaker",
            };
          }
        }
        let attributes = {
          name: cbData?.cbConfigData?.name,
          description: cbData?.cbConfigData?.description,
          motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
          loadCategory: cbData?.cbConfigData?.loadCategory,
          loadPriority: cbData?.cbConfigData?.loadPriority,
        };
        if (cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired") {
          attributes.type = "12";
        }
        if (cbData?.uiData?.contactor) {
          attributes.type = "20";
          attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
        }
        if (!cbData?.uiData?.contactor && !cbData?.cbConfigData?.motorized) {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
        if (!cbData?.uiData?.CBConfigured && (isDaasAnsiGrid || isDaasEtoGrid || isDaasIecGrid)) {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        } if (((isMgaasAnsiGrid || isMGaaSETOGrid || isNMGaaSETOGrid || isMgaasIecGrid) && isExportOptimization === false)) {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }

        if (((isDaasAnsiGrid) && isExportOptimization === false)) {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
        if (siteType === embLabels.GRID_CONNECTED_GSX && isDaasEtoGrid) {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
        if ((isMgaasIecIsland || isMGaaSETOIsland || isNMGaaSETOIsland || isMGaaSETOGensetPvHybrid || isNMGaaSETOGensetPvHybrid) && !cbData?.uiData?.cbRequired) {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;

        }
        cb.attributes = JSON.stringify(attributes);

        cb.connections.push(connectionsCb);
        cb.communications.push(communications);
        if ((projectKind?.isMgaasIecIsland || isNMGaaSETOIsland || projectKind?.isMgaasAnsiIsland || projectKind?.isDaasAnsiIsland || projectKind?.isDaasEtoIsland) && cbData.uiData.pmRequired) {
          let connectionList = [{
            componentIdx: `ASSET_${padNumberFormat(assetI)}`,
            endpointIdX: "1",
            connectionType: "electrical_connection",
          }];
          let PMComponentIdx = `PM_${loadCBI}`
          let cbNew = {};
          cbNew.assetId = cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
          cbNew.userId = 1;
          cbNew.componentIdx = PMComponentIdx;
          cbNew.componentName = cbData?.powerMeterData?.name ?? `PM_Load_${key + 1}`;;
          cbNew.componentType = "Power Meter";
          cbNew.connections = connectionList;
          cbNew.communications = [];
          cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset;
          cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
          let attributesnew = {
            name: cbData?.powerMeterData?.name,
            description: cbData?.powerMeterData?.description,
            powerMeterModbusId:
              cbData?.powerMeterData?.powerMeterModbusId,
          };

          cbNew.attributes = JSON.stringify(attributesnew);

          //* cb values

          let communicationsnew = {
            ip: cbData?.powerMeterData?.ipAddress,
            subnetmask: cbData?.powerMeterData?.mask,
            defaultGateway: cbData?.powerMeterData?.gatewayAddress,
            modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
            type: "Power Meter",
          };
          cbNew.communications.push(communicationsnew);
          arrayComponent.push(cbNew);
        }
        arrayComponent.push(cb);

        loadCBI = loadCBI + 1;

        //* skip 60 for ev
        if (loadCBI === 60) loadCBI = 61;
      }
      assetI = assetI + 1;

      return null;
    });

    //* ev

    let evCBI = 60;
    CBEVList?.map((cbData, key) => {
      // if (!cbData) return;
      if (cbData?.uiData?.status) {
        let ev = {};
        let checkTMH = cbData?.assetDetails?.[0]?.communicationModel?.toLowerCase() === "tmh_controller";
        if (cbData?.assetDetails?.length) {
          ev.assetId = cbData?.assetDetails?.[0]?.assetId;
        } else {
          ev.assetId = 5;
        }
        ev.userId = 1;
        ev.componentIdx = "ASSET_" + padNumberFormat(assetI);
        ev.componentId = cbData?.componentId ?? null;
        ev.uuid = cbData?.uuid ?? null;
        ev.componentName = cbData?.configData?.name;
        ev.componentType = "EV_charging_station";
        ev.connections = [];
        ev.communications = [];
        cbData.uiData.assetInfo = cbData?.assetDetails?.[0]
        ev.uiAttributes = JSON.stringify(cbData?.uiData);
        componentJson.deploymentReady =
          componentJson.deploymentReady && cbData?.uiData?.configured
            ? true
            : false;

        let connectionsEv = {
          componentIdx: "CB_" + evCBI,
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };
        let evattributes = {
          name: cbData?.configData?.name,
          description: cbData?.configData?.description,
          maximum_available_power: cbData?.configData?.maximum_available_power,
        };
        ev.attributes = JSON.stringify(evattributes);

        if (siteType === embLabels.ISLANDABLE || siteType === embLabels.GRID_CONNECTED) {
          ev.connections.push(connectionsEv);
        }

        if (cbData?.communicationData.ipaddress) {
          let evCommunications = {
            ip: cbData?.communicationData.ipaddress,
            subnetmask: cbData?.communicationData.subnetmask,
            defaultGateway: cbData?.communicationData.defaultGateway,
            modbusSlaveId: checkTMH ? 255 : cbData?.communicationData.modbusSlaveId,
            type: "EV_charging_station",
          };
          ev.communications.push(evCommunications);
        }
        arrayComponent.push(ev);
        if (siteType === embLabels.ISLANDABLE || siteType === embLabels.GRID_CONNECTED) {
          let cb = {};
          cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
          cb.userId = 1;
          if (cbData?.uiData?.cbRequired) {
            cb.componentIdx = "CB_" + evCBI;
            cb.componentName = cbData?.cbConfigData?.name;
            cb.componentType = "Circuit Breaker";
            cb.connections = [];
            cb.communications = [];
            cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails?.[0];
            cb.uiAttributes = JSON.stringify(cbData?.uiData);
            let connectionsCb = {
              componentIdx: "ASSET_" + padNumberFormat(assetI),
              endpointIdX: "1",
              connectionType: "electrical_connection",
            };
            let communications = {}
            if (cbData?.uiData?.cbRequired && cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo !== "Hardwired") {
              communications = {
                ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                subnetmask: cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                defaultGateway:
                  cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                modbusSlaveId:
                  cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                type: "Circuit Breaker",
              };
            } else {
              communications = {
                ip: '',
                subnetmask: '',
                defaultGateway: '',
                modbusSlaveId: '',
                type: "Circuit Breaker",
              };
            }
            let attributes = {
              name: cbData?.cbConfigData?.name,
              description: cbData?.cbConfigData?.description,
              motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
              loadCategory: cbData?.cbConfigData?.loadCategory,
              loadPriority: cbData?.cbConfigData?.loadPriority,
              Contactor_healthy_status_available: 0
            };
            if (cbData?.uiData?.contactor) {
              attributes.type = "20";
              attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
            }
            if (cbData?.cbConfigData?.motorized && cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired") {
              attributes.type = "12";
            }
            if (!cbData?.cbConfigData?.motorized && !cbData?.uiData?.contactor) {
              attributes.type = "40";
              attributes.loadCategory = 0;
              attributes.loadPriority = 0;
            }
            cb.attributes = JSON.stringify(attributes);

            cb.connections.push(connectionsCb);
            cb.communications.push(communications);
            arrayComponent.push(cb);
          }
        }

        if (
          (siteType === embLabels.GRID_CONNECTED || siteType === embLabels.ISLANDABLE) &&
          cbData?.uiData?.pmRequired
        ) {
          let cb = {};
          cb.assetId =
            cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
          cb.userId = 1;
          cb.componentIdx = "PM_60";
          cb.componentName = cbData?.powerMeterData?.name;
          cb.componentType = "Power Meter";
          cb.connections = [];
          cb.communications = [];
          cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter
          cb.uiAttributes = JSON.stringify(cbData?.uiData);
          let connections = {
            componentIdx: "ASSET_" + padNumberFormat(assetI),
            endpointIdX: "1",
            connectionType: "electrical_connection",
          };
          let attributes = {
            name: cbData?.powerMeterData?.name || "PM_EV",
            description: cbData?.powerMeterData?.description || "",
            powerMeterModbusId:
              cbData?.powerMeterData?.powerMeterModbusId || "103",
          };
          cb.attributes = JSON.stringify(attributes);

          //*cb values

          let communications = {};
          communications = {
            ip: cbData?.powerMeterData?.ipAddress,
            subnetmask: cbData?.powerMeterData?.subnetMask,
            defaultGateway: cbData?.powerMeterData?.defaultGateway,
            modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId || "103",
            type: "Power Meter",
          };
          cb.connections.push(connections);
          cb.communications.push(communications);
          arrayComponent.push(cb);
          assetCB = assetCB + 10;
        }
      }
      if (
        (siteType === embLabels.GRID_CONNECTED || siteType === embLabels.ISLANDABLE) &&
        cbData?.uiData?.contactor && !cbData?.cbConfigData?.motorized
      ) {
        let cbNew = {};
        cbNew.assetId =
          cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
        cbNew.userId = 1;
        cbNew.componentIdx = "Contactor_60";
        cbNew.componentName = cbData?.contactorConfigData?.name;
        cbNew.componentType = "Contactor";
        cbNew.connections = [];
        cbNew.communications = [];
        cbData.uiData.assetInfo = cbData?.contactorConfigData?.cbAssetDetails?.[0];
        cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
        let connections = {
          componentIdx: "CB_60",
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };
        let attributes = {
          name: cbData?.contactorConfigData?.name ?? "EV Contactor",
          description: cbData?.contactorConfigData?.description ?? "",
          loadCategory: cbData?.contactorConfigData?.loadCategory ?? 0,
          loadPriority: cbData?.contactorConfigData?.loadPriority ?? 0,
        };

        cbNew.attributes = JSON.stringify(attributes);

        //cbNew values
        let communications = {};

        cbNew.connections.push(connections);
        cbNew.communications.push(communications);
        arrayComponent.push(cbNew);
      }
      assetI = assetI + 1;

      return null;
    });

    let gtCBI = 39;
    CBGTList.map((cbData, key) => {
      if (!cbData.uiData.status) {
        return null;
      }
      if (cbData.uiData.status) {
        let gt = {};
        gt.assetId = 579;

        gt.userId = 1;
        gt.componentIdx = "ASSET_" + padNumberFormat(assetI);
        gt.componentId = cbData?.componentId ?? null;
        gt.uuid = cbData?.uuid ?? null
        gt.componentName = cbData?.configData?.name;
        gt.componentType = "Grounding_Transformer";
        gt.connections = [];
        gt.communications = [];
        cbData.uiData.assetInfo = cbData?.assetDetails?.[0]
        gt.uiAttributes = JSON.stringify(cbData.uiData);
        componentJson.deploymentReady =
          componentJson.deploymentReady && cbData.uiData.configured
            ? true
            : false;

        let connectionsGt = {
          componentIdx: "CB_" + gtCBI,
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };
        let gtAttributes = {
          name: cbData.configData.name,
          description: cbData.configData.description,
          maximum_available_power: cbData.configData.maximum_available_power,
        };
        gt.attributes = JSON.stringify(gtAttributes);

        if (siteType === embLabels.ISLANDABLE) {
          gt.connections.push(connectionsGt);
        }

        if (cbData.communicationData.ipaddress) {
          let gtCommunications = {
            ip: cbData.communicationData.ipaddress,
            subnetmask: cbData.communicationData.subnetmask,
            defaultGateway: cbData.communicationData.defaultGateway,
            modbusSlaveId: cbData.communicationData.modbusSlaveId,
            type: "Grounding Transformer",
          };
          gt.communications.push(gtCommunications);
        }
        arrayComponent.push(gt);
        if (siteType === embLabels.ISLANDABLE || siteType === embLabels.ISLANDABLE_GSX) {
          let cb = {};
          cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 8;
          cb.userId = 1;
          if (cbData?.uiData?.cbRequired) {
            cb.componentIdx = "CB_" + gtCBI;
            cb.componentName = cbData.cbConfigData.name;
            cb.componentType = "Circuit Breaker";
            cb.connections = [];
            cb.communications = [];
            cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails?.[0];
            cb.uiAttributes = JSON.stringify(cbData.uiData);
            let connectionsCb = {
              componentIdx: "ASSET_" + padNumberFormat(assetI),
              endpointIdX: "1",
              connectionType: "electrical_connection",
            };
            let communications = {}
            if (cbData?.uiData?.cbRequired && cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo !== "Hardwired") {
              communications = {
                ip: cbData.cbConfigData.cbCommunicationData.ipaddress,
                subnetmask: cbData.cbConfigData.cbCommunicationData.subnetmask,
                defaultGateway:
                  cbData.cbConfigData.cbCommunicationData.defaultGateway,
                modbusSlaveId:
                  cbData.cbConfigData.cbCommunicationData.modbusSlaveId,
                type: "Circuit Breaker",
              };
            } else {
              communications = {
                ip: '',
                subnetmask: '',
                defaultGateway: '',
                modbusSlaveId: '',
                type: "Circuit Breaker",
              };
            }
            let attributes = {
              name: cbData.cbConfigData.name,
              description: cbData.cbConfigData.description,
              motorized: cbData.cbConfigData.motorized ? 1 : 0,
              loadCategory: cbData.cbConfigData.loadCategory,
              loadPriority: cbData.cbConfigData.loadPriority,
              Contactor_healthy_status_available: 0
            };
            if (cbData?.uiData?.contactor) {
              attributes.type = "20";
              attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
            }
            if (cbData?.cbConfigData?.motorized && cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired") {
              attributes.type = "12";
            }
            if (!cbData?.cbConfigData?.motorized && !cbData?.uiData?.contactor) {
              attributes.type = "40";
              attributes.loadCategory = 0;
              attributes.loadPriority = 0;
            }
            cb.attributes = JSON.stringify(attributes);

            cb.connections.push(connectionsCb);
            cb.communications.push(communications);
            arrayComponent.push(cb);
          }
        }
      }
      if (
        (siteType === embLabels.ISLANDABLE) &&
        cbData?.uiData?.contactor && !cbData.cbConfigData.motorized
      ) {
        let cbNew = {};
        cbNew.assetId =
          cbData.contactorConfigData.cbAssetDetails[0]?.assetId ?? 8;
        cbNew.userId = 1;
        cbNew.componentIdx = "Contactor_60";
        cbNew.componentName = cbData?.contactorConfigData?.name;
        cbNew.componentType = "Contactor";
        cbNew.connections = [];
        cbNew.communications = [];
        cbData.uiData.assetInfo = cbData?.contactorConfigData?.cbAssetDetails?.[0];
        cbNew.uiAttributes = JSON.stringify(cbData.uiData);
        let connections = {
          componentIdx: "CB_75",
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };
        let attributes = {
          name: cbData?.contactorConfigData?.name ?? "GT Contactor",
          description: cbData?.contactorConfigData?.description ?? "",
          loadCategory: cbData?.contactorConfigData?.loadCategory ?? 0,
          loadPriority: cbData?.contactorConfigData?.loadPriority ?? 0,
        };

        cbNew.attributes = JSON.stringify(attributes);

        //cbNew values
        let communications = {};

        cbNew.connections.push(connections);
        cbNew.communications.push(communications);
        arrayComponent.push(cbNew);
      }
      assetI = assetI + 1;

      return null;
    });

    //* Apply priority rules from extracted utility
    applyPriorityRules(arrayComponent);

    const generatedComponents = assignIpAddress(arrayComponent, communicationState, CBAssetList, CBLoadList, CBEVList, assetDefaultValues);
    componentJson.components = preserveGeneratedComponentIdentity(generatedComponents);
    componentJson.diagramChangeRequired = false;
    componentJson.evceDiagramChangeRequired = false;
    componentJson.bessTransitionChangeRequest = false;

    // The load loop emits unconditionally while DERs are gated on uiData.status, so a build that runs
    // before CBAssetList commits yields a loads-only payload. Never persist that.
    const activeDerCount = CBAssetList?.filter((cbData) => cbData?.uiData?.status).length ?? 0;
    const generatedDerCount = componentJson.components.filter((component) =>
      ["Utility", "Genset", "BESS", "CHP", "Hybrid", "Inverter"].includes(component.componentType)
    ).length;
    if (activeDerCount > 0 && generatedDerCount === 0) {
      console.warn("generateComponentsBlock: DERs missing from payload, skipping update");
      return;
    }
    const forceTransitionUpdate = sessionStorage.getItem(FORCE_TRANSITION_UPDATE_KEY) === "true";

    if (UserScope.access.saveSLD === true) {
      const deploymentReadyState = checkAssetStatus();
      componentJson.deploymentReady = deploymentReadyState;
      upDateCbcount(componentJson.components);
      setUpdateComponents(prev => ({
        ...prev,
        updateComponents: componentJson.components
      }));
      let shouldPersistComponents = false;
      if (forceTransitionUpdate) {
        shouldPersistComponents = true;
        sessionStorage.removeItem(FORCE_TRANSITION_UPDATE_KEY);
      } else if (deploymentReadyState) {
        shouldPersistComponents = true;
      } else if (firstTimeCall) {
        if (projectKind?.isMgaasAnsi || projectKind?.isDaasAnsi || projectKind?.isDaasEto) {
          componentJson.connectionType = "LOAD_SIDE";
        }
        shouldPersistComponents = true;
        setFirstTimecall(false);
      } else if (multipleLoads) {
        componentJson.isAllowMultipleLoads = false;
        setMultipleLoads(false);
        shouldPersistComponents = true;
      }

      if (shouldPersistComponents) {
        sessionStorage.setItem("componentDataModified", false);
        updateComponentRemote(componentJson);
      }


      ComponentDataDispatch({
        type: ACTIONS.UPDATE_COMPONENT_DATA,
        payload: componentJson
      });
      //* update pv communication

      PVDetailsDispatch({
        type: ACTIONS.UPDATE_PV_COMMUNICATION_COMPONENT,
        payload: {
          components: componentJson.components,
          externalId: gsxExternalId.utilityExternalId,
          projectTypeValue,
        },
      });
      checkExportOptimizationCondition();
      sessionStorage.setItem("componentJsonData", JSON.stringify(componentJson));
      setCurrentProject((prevData) => ({
        ...prevData,
        componentData: componentJson
      }))

    };
  };
 const updateResources = async (componentJson) => {
    if( !projectKind?.isNMGaaSETO){
      return;
    }
   let activeDers = componentJson.filter(item =>["utility","genset","bess","inverter","load"].includes(item.componentType.toLowerCase()));
    let tagDetails ={};
      let tagDetailsJson = {};
    try {
      const json = await apiSession.getResources(projectId);
      if(json?.resources && json?.resources?.length > 0) {
        tagDetails = json;
      }   
    } catch (error) {
      console.log("Error fetching tags details:", error);
      return;
    }
    if(tagDetails && tagDetails?.resources?.length > 0) {
        const existingResources = tagDetails?.resources;
        const newResources = activeDers
          .filter(
            item => !existingResources.some(
              resource =>
                resource.resourceType.toLowerCase()  === item.componentType.toLowerCase() &&
                resource.resourceName.toLowerCase()  === item.componentName.toLowerCase(),
            ),
          );
        const newResourcesMapped = newResources.map(item => ({
            resourceId: null,
            resourceType: item.componentType,
            resourceName: item.componentName,
            tagList: [],
          }));
        const updatedResources = [...existingResources, ...newResourcesMapped];
        tagDetailsJson = {
          siteId: tagDetails?.siteId ?? null,
          projectId: projectId,
          resources: updatedResources,
        };
         handleSaveResources(tagDetailsJson);
    }else{
       tagDetailsJson = {
        "siteId": tagDetails?.siteId ?? null,
        "projectId": projectId,
        resources: activeDers.map(item => ({
          resourceId: null,
          resourceType: item.componentType,
          resourceName:  item.componentName,
          tagList: [],
        }))
      }
      handleSaveResources(tagDetailsJson);
    }
    
 }
 const handleSaveResources =(data) =>{
   try {
    apiSession.saveResources(data);
   } catch (error) {
    console.log("Error saving resources:", error);
   }
 }
  const updateComponentRemote = (componentJson) => {
    if (isUpdatingComponent.current) {
      pendingComponentUpdateRef.current = _.cloneDeep(componentJson);
      console.log("updateComponentRemote already in progress, queueing latest payload");
      return;
    }
    isUpdatingComponent.current = true;
    setLoading(true);
    apiSession
      .updateComponents(componentJson)
      .then((json) => {
        if(json?.components && json?.components.length > 0 && json?.deploymentReady) {
           updateResources(json?.components)
        }
        setJsonData(json?.components)
        getCBDetails(json?.components);
        setSwitchboardType(json?.switchboardType);
        setIsEvce(json?.isElectricalVehicleEnergyManagement);
        setRemoteMain(json?.remoteMain);
        setLoadSide(json?.connectionType);
        setCurrentProject((prevData) => ({
          ...prevData,
          componentData: json?.components,
          timeSettingsValidated: json?.systemsTimeSyncPage,
          secureArchitecturePage: json?.secureArchitecturePage,
          showUseCase: json?.deploymentReady,
          showSystems: !json?.programPage,
          showBOM: json.systemsPage === false && json.secureArchitecturePage === true && json.systemsTimeSyncPage === true && !json?.programPage,
          showDeploy: json.systemsPage === false && json.secureArchitecturePage === true && json.systemsTimeSyncPage === true && !json?.programPage,
        }));
          const dersUpdateAvailable = siteCreated && !( json.systemsPage === false && json.secureArchitecturePage === true && json.systemsTimeSyncPage === true && !json?.programPage);
        sessionStorage.setItem("dersUpdateAvailable", dersUpdateAvailable);
        ComponentDataDispatch({
          type: ACTIONS.UPDATE_COMPONENT_DATA,
          payload: json
        })
        projectKindDispatch({
          type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
          payload: { ...json, projectTypeValue },
        });
        //* update pv communication

        PVDetailsDispatch({
          type: ACTIONS.UPDATE_PV_COMMUNICATION_COMPONENT,
          payload: {
            components: json?.components,
            externalId: gsxExternalId.utilityExternalId,
            projectTypeValue: projectTypeValue
          },
        });
        setUpdateComponents(prev => ({
          ...prev,
          updateComponents: json?.components
        }));
        setLoading(false);
        sessionStorage.setItem("programPage", true);
        sessionStorage.setItem("communicationValidated", json?.systemsPage);
        sessionStorage.setItem("componentDataModified", false);
        sessionStorage.setItem("assetEditStatus", `"",false`);
        setDuplicateUpdate({
          der: "",
          load: "",
          pv: "",
          ev: "",
        });
        if (defaultConfigurationStatus) {
          callSnackbar("success", embLabels.defaultConfigurationCreated);
          const defaultConfigurationStatusNew = false;
          setDefaultConfigurationStatus(defaultConfigurationStatusNew);
        } else {

          callSnackbar("success", embLabels.configurationUpdatedSuccess);
        }
        if (deleteOneDER) {
          sessionStorage.setItem("deploymentReady", false);
          setDeploymentReady("false");
          checkGensetDeleteOneDER(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response) {
          if (error?.response?.status === 400) {
            if (duplicateUpdate.der !== "") {
              CBAssetListDispatch({
                type: ACTIONS.DUPLICATE_DER_UPDATE,
                payload: {
                  selectedAsset: duplicateUpdate.der,
                },
              });
            }
            if (duplicateUpdate.load !== "") {
              CBLoadListDispatch({
                type: ACTIONS.DUPLICATE_LOAD_UPDATE,
                payload: {
                  selectedLoad: duplicateUpdate.load,
                },
              });
            }
            if (duplicateUpdate.ev !== "") {
              CBEVListDispatch({
                type: ACTIONS.DUPLICATE_EV_UPDATE,
                payload: {
                  selectedEv: duplicateUpdate.ev,
                },
              });
            }
            if (duplicateUpdate.pv !== "") {
              PVDetailsDispatch({
                type: ACTIONS.DUPLICATE_PV_UPDATE,
              });
              PVDetailsDispatch({
                type: ACTIONS.PV_CONFIGURED_STATUS,
              });
            }
          }
          if (error?.response?.data?.message === "Too many request") {
            window.location.reload();
          } else {
            callSnackbar("error", error?.response?.data?.message);
          }

        } else {
          callSnackbar("error", embLabels.errorInUpdatingConfiguration);
        }
        if (deleteOneDER) {
          sessionStorage.setItem("deploymentReady", false);
          setDeploymentReady("false");
          checkGensetDeleteOneDER(true);
        }
      })
      .finally(() => {
        isUpdatingComponent.current = false;
        const queuedPayload = pendingComponentUpdateRef.current;
        pendingComponentUpdateRef.current = null;
        if (queuedPayload) {
          updateComponentRemote(queuedPayload);
        }
      });
  };

  const getCBDetails = (components) => {
    const CBIFEDETAILS = components?.filter(
      (component) =>
        component.communications.length &&
        component.componentType === "Circuit Breaker"
    );
    const CBDETAILS = CBIFEDETAILS.map((component) => ({
      [component?.componentIdx]: {
        ip: component?.communications?.[0]?.ip ?? "",
        gateway: component?.communications?.[0]?.defaultGateway ?? "",
        mask: component?.communications?.[0]?.subnetmask ?? "",
        modbus: component?.communications?.[0]?.modbusSlaveId ?? "",
        assetId: component?.asset?.assetId,
        numberOfDevicesIFE: component?.asset?.assetAttributes?.[0]?.value,
      },
    }));

    const CBVALUES = Object.assign({}, ...CBDETAILS);
    setCBValues(CBVALUES);
    const usedIps = CBIFEDETAILS.map(
      (cbdetail) => cbdetail.communications[0].ip
    );
    const usedIfeSet = CBIFEDETAILS.map((cbdetail) => [
      cbdetail.communications[0].ip,
      cbdetail.asset.assetAttributes[0].value,
    ]);
    const ifeIpSets = {};
    for (let [usedIp, maxValue] of usedIfeSet) {
      if (ifeIpSets[usedIp]) {
        ifeIpSets[usedIp][0] = ifeIpSets[usedIp][0] + 1;
      } else {
        ifeIpSets[usedIp] = [1, +maxValue];
      }
    }
    setCbCommunicationValues((prevState) => ({
      ...prevState,
      usedIps,
      ifeIpSets,
      availableIps: prevState?.allIps?.filter(
        (ifeIp) => !usedIps.includes(ifeIp)
      ),
    }));
  };

  const assignComponents = (component, contactor, isAllowMultipleLoads, isExportOptimization) => {
    let components = component?.components;
    let loadCBIndex = 0;
    let loadIndex = 0;
    let pvNo1 = 0;
    let pvNo2 = 0;
    let pvNo3 = 0;

    components?.sort((a, b) => a.componentIdx.localeCompare(b.componentIdx));

    //* update pv communication
    PVDetailsDispatch({
      type: ACTIONS.UPDATE_EMPTY_PVCOMMUNICATION,
      payload: {
        ["componentsData"]: components,
        projectTypeValue: projectTypeValue
      },
    });
    const loadPMIDArray = ["PM_50", "PM_51", "PM_52", "PM_53", "PM_54", "PM_55", "PM_56", "PM_57", "PM_58", "PM_59"];
    const loadPMIDArray2 = ["PM_61", "PM_62", "PM_63", "PM_64", "PM_65", "PM_66", "PM_67", "PM_68", "PM_69", "PM_70", "PM_71", "PM_72", "PM_73", "PM_74"]
    const loadContactorIDArray = ["Contactor_50", "Contactor_51", "Contactor_52", "Contactor_53", "Contactor_54", "Contactor_55", "Contactor_56", "Contactor_57", "Contactor_58", "Contactor_59"];
    const LoadEMArray = ["CB_50", "CB_51", "CB_52", "CB_53", "CB_54", "CB_55", "CB_56", "CB_57", "CB_58", "CB_59", "CB_61", "CB_62", "CB_63", "CB_64", "CB_65", "CB_66", "CB_67", "CB_68", "CB_69", "CB_70", "CB_71", "CB_72", "CB_73", "CB_74"]
    components?.map((componentsData) => {
      if (!componentsData) return;
      switch (componentsData?.componentType) {
        case embLabels.UTILITY:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_UTILITY,
            payload: { componentsData: componentsData, projectTypeValue },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          if (
            component.siteType === embLabels.ISLANDABLE_GSX ||
            component.siteType === embLabels.GRID_CONNECTED_GSX
          ) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              utilityExternalId: componentsData.externalId
                ? componentsData.externalId
                : "",
            }));
          }
          break;

        case embLabels.GENSET:
          //default value for genset power, site is Access to Energy
          const assetAttributesNew = JSON.parse(componentsData?.attributes);
          if (
            component?.siteType === "GENSET_PVBESS_A2E" &&
            assetAttributesNew?.max_power === "1200"
          ) {
            assetAttributesNew.max_power = "130";
            componentsData.attributes = JSON.stringify(assetAttributesNew);
          }

          CBAssetListDispatch({
            type: ACTIONS.UPDATE_GENSET,
            payload: { componentsData: componentsData, switchboardType: component?.switchboardType },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          if (component.siteType === embLabels.ISLANDABLE_GSX) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              gensetExternalId: componentsData.externalId
                ? componentsData.externalId
                : "",
            }));
          }
          break;

        case embLabels.BESS:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_BESS,
            payload: {
              componentsData: componentsData,
              batteryCommunicationData,
              setBatteryCommunicationData,
              contactor,
              projectTypeValue
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          if (
            component.siteType === embLabels.GRID_CONNECTED_GSX ||
            component.siteType === embLabels.ISLANDABLE_GSX
          ) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              batteryExternalId: componentsData.externalId
                ? componentsData.externalId
                : "",
            }));
          }
          break;

        case embLabels.INVERTER:
          const uiData = JSON.parse(componentsData.uiAttributes);

          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_COMMUNICATION,
            payload: {
              componentsData: componentsData,
              projectTypeValue: projectTypeValue
            },
          });

          if (uiData.pv === 1) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_PV,
              payload: {
                componentsData,
                pvArray: 3,
                projectTypeValue
              },
            });

            if (pvNo1 === 0) {
              countDispatch({
                type: ACTIONS.UPDATE_DER_COUNT,
                payload: { count: 1 },
              });
            }

            PVDetailsDispatch({
              type: ACTIONS.UPDATE_PVSET,
              payload: {
                componentsData,
                pvArray: 3,
              },
            });

            pvNo1++;
          } else if (uiData.pv === 2) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_PV,
              payload: {
                componentsData,
                pvArray: 4,
              },
            });

            if (pvNo2 === 0) {
              countDispatch({
                type: ACTIONS.UPDATE_DER_COUNT,
                payload: { count: 1 },
              });
            }

            PVDetailsDispatch({
              type: ACTIONS.UPDATE_PVSET,
              payload: {
                componentsData,
                pvArray: 4,
              },
            });
            pvNo2++;
          } else if (uiData.pv === 3) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_PV,
              payload: {
                componentsData,
                pvArray: 5,
              },
            });
            if (pvNo3 === 0) {
              countDispatch({
                type: ACTIONS.UPDATE_DER_COUNT,
                payload: { count: 1 },
              });
            }

            PVDetailsDispatch({
              type: ACTIONS.UPDATE_PVSET,
              payload: {
                componentsData,
                pvArray: 5,
              },
            });

            pvNo3++;
          }

          break;

        case embLabels.CHP:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_CHP,
            payload: {
              componentsData: componentsData,
            },
          });

          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          break;

        case embLabels.HYBRID:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_HYBRID,
            payload: {
              componentsData: componentsData,
            },
          });

          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          break;

        case embLabels.LOAD:
          const uiAttributes = JSON.parse(componentsData?.uiAttributes);
          if (uiAttributes.isRemoteLoad) {
            countDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
              payload: { count: 1 },
            });
          } else {
            countDispatch({
              type: ACTIONS.UPDATE_LOAD_COUNT,
              payload: { count: 1 },
            });
          }
          CBLoadListDispatch({
            type: ACTIONS.UPDATE_LOAD,
            payload: { componentsData, loadIndex, siteType: component.siteType, projectTypeValue, isAllowMultipleLoads },
          });

          //   CBLoadListUpdated = newLoadData;
          loadIndex++;

          break;

        case embLabels.EV_CHARGING_STATION:
          if (component.evceDiagramChangeRequired) {
            // nothing is doing
          } else {
            countDispatch({
              type: ACTIONS.UPDATE_EV_COUNT,
              payload: { count: 1 },
            });
            CBEVListDispatch({
              type: ACTIONS.UPDATE_EV,
              payload: {
                componentsData,
                evCommunicationData,
                setEvCommunicationData,
              },
            });
          }
          break;
        case embLabels.GROUNDING_TRANSFORMER:
          if (component.gridTransitionOnline !== "OPEN") {
            // nothing is doing
          } else {
            countDispatch({
              type: ACTIONS.UPDATE_GT_COUNT,
              payload: { count: 1 },
            });
            CBGTListDispatch({
              type: ACTIONS.UPDATE_GT,
              payload: {
                componentsData,
              },
            });
          }
          break;
        case embLabels.CIRCUIT_BREAKER:

          if (componentsData.componentIdx === "CB_10") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 0,
                projectTypeValue
              },
            });
          } else if (componentsData.componentIdx === "CB_20") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 1,
              },
            });
          } else if (componentsData.componentIdx === "CB_30") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 2,
              },
            });
          } else if (componentsData.componentIdx === "CB_80") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 6,
              },
            });
          } else if (componentsData.componentIdx === "CB_90") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 7,
              },
            });
          } else if (componentsData.componentIdx === "CB_40") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 3,
              },
            });
          } else if (componentsData.componentIdx === "CB_41") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 4,
              },
            });
          } else if (componentsData.componentIdx === "CB_42") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 5,
              },
            });
          } else if (componentsData.componentIdx === "CB_60") {
            CBEVListDispatch({
              type: ACTIONS.UPDATE_EV_CB,
              payload: { componentsData },
            });
          } else if (componentsData.componentIdx === "CB_75") {
            CBGTListDispatch({
              type: ACTIONS.UPDATE_GT_CB,
              payload: { componentsData },
            });
          }
          else if (LoadEMArray.includes(componentsData.componentIdx)) {
            LoadEMArray.forEach((loadData, index) => {
              if (loadData === componentsData.componentIdx) {
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_LOAD_CB,
                  payload: {
                    componentsData,
                    loadCBIndex: index,
                    siteType: component.siteType,
                    projectTypeValue,
                    contactor: contactor,
                    isExportOptimization: isExportOptimization ?? false
                  },
                });
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_EM_LOAD,
                  payload: {
                    componentsData,
                    value: index,
                    projectTypeValue: projectTypeValue
                  },
                });

              }
            })
          }
          else {
            // CBLoadListDispatch({
            //   type: ACTIONS.UPDATE_LOAD_CB,
            //   payload: { 
            //     componentsData, 
            //     loadCBIndex:15,
            //     siteType:component.siteType,
            //     projectTypeValue,
            //      contactor: contactor },
            // });
            // loadCBIndex += 1;
          }
          break;

        case embLabels.CONTACTOR:
          if (componentsData.componentIdx === "Contactor_30") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 2,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_40") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 3,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_41") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 4,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_42") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 5,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_60") {
            CBEVListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 0,
              },
            });
          }
          if (loadContactorIDArray.includes(componentsData.componentIdx)) {
            loadContactorIDArray.forEach((loadData, index) => {
              if (loadData === componentsData.componentIdx) {
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
                  payload: {
                    componentsData,
                    value: index,
                  },
                });
              }
            })
          }
          break;

        case embLabels.POWER_METER:
          if (["PM_10", "CB_10"].includes(componentsData.componentIdx)) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 0,
              },
            });
          } else if (componentsData.componentIdx === "PM_20") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 1,
              },
            });
          } else if (componentsData.componentIdx === "PM_40") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 3,
              },
            });
          } else if (componentsData.componentIdx === "PM_41") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 4,
              },
            });
          } else if (componentsData.componentIdx === "PM_42") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 5,
              },
            });
          } else if (componentsData.componentIdx === "PM_30") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 2,
              },
            });
          } else if (componentsData.componentIdx === "PM_80") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 6,
              },
            });
          } else if (componentsData.componentIdx === "PM_60") {
            CBEVListDispatch({
              type: ACTIONS.UPDATE_EV_PM,
              payload: { componentsData },
            });
          }
          //  else if (componentsData.componentIdx === "PM_50"&&!(component.siteType===embLabels.ISLANDABLE&& (projectTypeValue==="MGaaS IEC" || projectTypeValue === "MGaaS ETO"))) {
          //     CBAssetListDispatch({
          //       type: ACTIONS.UPDATE_DER_EXISTING_PM,
          //       payload: {
          //         componentsData,
          //         value: 0,
          //       },
          //     });
          //   }
          else if (["PM_50", "PM_51", "PM_52", "PM_53", "PM_54", "PM_55", "PM_56", "PM_57", "PM_58", "PM_59"].includes(componentsData.componentIdx) && ([embLabels.ISLANDABLE, embLabels.OFF_GRID, embLabels.ISLANDABLE_GSX].includes(component.siteType) && ["NMGaaS ETO", "MGaaS ETO", "MGaaS IEC", "MGaaS ANSI", "DaaS ANSI", "DaaS ETO"].includes(projectTypeValue))) {
            let foundPM = false;
            for (let index = 0; index < loadPMIDArray.length; index++) {
              const item = loadPMIDArray[index];
              if (item === componentsData.componentIdx) {
                if (item === "PM_59") {
                  // debugger
                }
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_DER_EXISTING_PM,
                  payload: {
                    componentsData,
                    value: index,

                  },
                });
                foundPM = true;
                break; // Exit the loop once the condition is met
              }
            }
          } else if (["PM_61", "PM_62", "PM_63", "PM_64", "PM_65", "PM_66", "PM_67", "PM_68", "PM_69", "PM_70", "PM_71", "PM_72", "PM_73", "PM_74"].includes(componentsData.componentIdx) && ([embLabels.ISLANDABLE, embLabels.OFF_GRID, embLabels.ISLANDABLE_GSX].includes(component.siteType) && ["NMGaaS ETO", "MGaaS ETO", "MGaaS IEC", "MGaaS ANSI", "DaaS ANSI", "DaaS ETO"].includes(projectTypeValue))) {
            let foundPM = false;
            for (let index = 0; index < loadPMIDArray2.length; index++) {
              const item = loadPMIDArray2[index];
              if (item === componentsData.componentIdx) {
                if (item === "PM_59") {
                  // debugger
                }
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_DER_EXISTING_PM,
                  payload: {
                    componentsData,
                    value: index + 10,

                  },
                });
                foundPM = true;
                break; // Exit the loop once the condition is met
              }
            }
          }
          //   else if (componentsData.componentIdx === "PM_51") {
          //   CBAssetListDispatch({
          //     type: ACTIONS.UPDATE_DER_EXISTING_PM,
          //     payload: {
          //       componentsData,
          //       value: 3,
          //     },
          //   });
          // }  
          else {
            // do nothing
          }

          break;

        default:
          break;
      }
      return null;
    });
    const runCalculateCoordinatesNew = { componentPush: false };
    setRunCalculateCoordinates(runCalculateCoordinatesNew);
    setSldLoadCompleted(true);
    setLoading(false);

  };


  return {
    calculateCoOridinates,
    checkAssetStatus,
    checkExportOptimizationCondition,
    saveDraftComponentData,
    generateComponentsBlock,
    updateComponentRemote,
    getCBDetails,
    assignComponents,
  };
};

export default useGenerateComponents;